webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(289)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-46a53c22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules__ = __webpack_require__(215);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({

  strict: "production" !== 'production',

  modules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__modules__),

  getters: {
    isPopupOpened: function isPopupOpened(state) {
      return state.menu.opened || state.form.opened;
    },
    isPopupAnimating: function isPopupAnimating(state, getters) {
      return getters['app/isAnimating'];
    }
  },

  mutations: {
    openPopup: function openPopup(state, popup) {
      state[popup].opened = true;
    },

    closePopup: function closePopup(state, routeChanged) {
      state.menu.opened = state.form.opened = false;

      if (routeChanged) {
        state.app.routeChangedFromPopup = true;
      } else {
        state.app.routeChangedFromPopup = false;
      }
    }
  }

});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(504),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e2199b82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(502),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c739e8ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(468),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c7cb43c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_logger__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_delayer__ = __webpack_require__(210);





var api = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].api
});

if (false) {
  logger(api);
  delayer(api);
}

/* harmony default export */ __webpack_exports__["b"] = ({

  meta: {
    get: function get(lang) {
      return api.get('/sitemap', {
        headers: {
          'Accept-Language': lang
        }
      });
    }
  },

  pages: {
    getAll: function getAll() {
      return api.get('/pages');
    },
    getDefault: function getDefault(url, name) {

      if (!name) return api.get(url);

      return api.get(url + '/' + name);
    },
    get: function get(url) {
      return api.get('/pages/' + url);
    },
    getByType: function getByType(name, limit, offset) {
      return api.get(name, {
        params: {
          limit: limit,
          offset: offset
        }
      });
    }
  },

  form: {
    send: function send(data) {
      return api.post('/connects/create', data);
    }
  }

  // settings: {
  //   get () {
  //     return api.get('/constructors')
  //   },

  //   update (id, data) {
  //     return api.put(`/constructors/${id}`, data)
  //   }
  // },

  // products: {
  //   get () {
  //     return api.get('/products')
  //   },

  //   create (data) {
  //     return api.post('/products', data)
  //   },

  //   remove (id) {
  //     return api.delete(`/products/${id}`)
  //   },

  //   update (id, data) {
  //     return api.put(`/products/${id}`, data)
  //   }
  // },

  // certificates: {
  //   get () {
  //     return api.get('/certificates')
  //   },

  //   create (data) {
  //     return api.post('/certificates', data)
  //   },

  //   remove (id) {
  //     return api.delete(`/certificates/${id}`)
  //   },

  //   update (id, data) {
  //     return api.put(`/certificates/${id}`, data)
  //   }
  // },

  // schemes: {
  //   get () {
  //     return api.get('/principal-schemas')
  //   },

  //   create (data) {
  //     return api.post('/principal-schemas', data)
  //   },

  //   remove (id) {
  //     return api.delete(`/principal-schemas/${id}`)
  //   },

  //   update (id, data) {
  //     return api.put(`/principal-schemas/${id}`, data)
  //   }
  // },

  // proposals: {
  //   get () {
  //     return api.get('/commercial-proposals')
  //   },

  //   remove (id) {
  //     return api.delete(`/commercial-proposals/${id}`)
  //   }
  // },

  // files: {
  //   save (data) {
  //     return api.post(`${config.host}/api/file`, data)
  //   },

  //   convert (data) {
  //     return api.post(`${config.host}/api/process-file`, data)
  //   }
  // },

  // pdf: {
  //   render (data) {
  //     return api.post(`${config.host}/api/pdf`, data)
  //       .then((response) => {
  //         return response.data
  //       })
  //   }
  // },

  // user: {
  //   authorize (name, password) {
  //     return api.post(`/client/token`, {
  //       clientName: name,
  //       password
  //     })
  //   }
  // }

});

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(486),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57223f09",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(470),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24283a43",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjIxcHgiIGhlaWdodD0iMTNweCIgdmlld0JveD0iMCAwIDIxIDEzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkuMSAoNTExNDcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPg0KICAgIDx0aXRsZT5Db21iaW5lZCBTaGFwZTwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGRlZnM+PC9kZWZzPg0KICAgIDxnIGlkPSIxMzY2IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9ImZvcm0iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MDQuMDAwMDAwLCAtNjc4LjAwMDAwMCkiIGZpbGw9IiNFRTZCNEMiPg0KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU0Mi4wMDAwMDAsIDY2Ny4wMDAwMDApIj4NCiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjcxLjMwMTQ2NiwxOS41MjQ0ODY2IEwyNjIsMTkuNTI0NDg2NiBMMjYyLDE1LjUyOTkyMTMgTDI3MS4zMDE0NjYsMTUuNTI5OTIxMyBMMjcxLjMwMTQ2NiwxMSBMMjc1LjQ1MDUxNSwxMy4zNjA5NTg1IEwyNzguNTA4NzgsMTUuMTAxMTkyNyBMMjgyLjcxNDUwOSwxNy40OTQzMjEgTDI3OC41MDg3OCwxOS44ODc3NTU4IEwyNzUuNDUwNTE1LDIxLjYyNzk4OTkgTDI3MS4zMDE0NjYsMjMuOTg4OTQ4NSBMMjcxLjMwMTQ2NiwxOS41MjQ0ODY2IFoiIGlkPSJDb21iaW5lZC1TaGFwZSI+PC9wYXRoPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+"

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjIxcHgiIGhlaWdodD0iMTNweCIgdmlld0JveD0iMCAwIDIxIDEzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkuMSAoNTExNDcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPg0KICAgIDx0aXRsZT5Db21iaW5lZCBTaGFwZSBDb3B5PC90aXRsZT4NCiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4NCiAgICA8ZGVmcz48L2RlZnM+DQogICAgPGcgaWQ9IjEzNjYiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8ZyBpZD0iZm9ybSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU0Mi4wMDAwMDAsIC02NzguMDAwMDAwKSIgZmlsbD0iI0VFNkI0QyI+DQogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTQyLjAwMDAwMCwgNjY3LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05LjMwMTQ2NjAxLDE5LjUyNDQ4NjYgTDAsMTkuNTI0NDg2NiBMMCwxNS41Mjk5MjEzIEw5LjMwMTQ2NjAxLDE1LjUyOTkyMTMgTDkuMzAxNDY2MDEsMTEgTDEzLjQ1MDUxNTUsMTMuMzYwOTU4NSBMMTYuNTA4Nzc5OSwxNS4xMDExOTI3IEwyMC43MTQ1MDk1LDE3LjQ5NDMyMSBMMTYuNTA4Nzc5OSwxOS44ODc3NTU4IEwxMy40NTA1MTU1LDIxLjYyNzk4OTkgTDkuMzAxNDY2MDEsMjMuOTg4OTQ4NSBMOS4zMDE0NjYwMSwxOS41MjQ0ODY2IFoiIGlkPSJDb21iaW5lZC1TaGFwZS1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMC4zNTcyNTUsIDE3LjQ5NDQ3NCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTAuMzU3MjU1LCAtMTcuNDk0NDc0KSAiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(500),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f32357c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(465),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09ed8366",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(473),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d38927e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
  __webpack_require__(268)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03e719ca",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_the_content__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_the_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_the_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_home__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_about__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_contacts__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_contacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_list_news__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_list_news___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_list_news__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_list_projects__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_list_projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_list_projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_post__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_error__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_error__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__layout_the_content___default.a,
    children: [{
      path: '/:lang?',
      name: 'home',
      component: __WEBPACK_IMPORTED_MODULE_3__pages_home___default.a
    }, {
      path: '/:lang/about',
      name: 'about',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_about___default.a
    }, {
      path: '/:lang/contacts',
      name: 'contacts',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_contacts___default.a
    }, {
      path: '/:lang/news',
      name: 'news',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_list_news___default.a
    }, {
      path: '/:lang/news/:slug',
      name: 'story',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_post___default.a
    }, {
      path: '/:lang/projects',
      name: 'projects',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_list_projects___default.a
    }, {
      path: '/:lang/projects/:slug',
      name: 'project',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_post___default.a
    }, {
      path: '/:lang/error',
      name: 'error',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_error___default.a
    }, {
      path: '/:lang?/*',
      name: 'not-found',
      redirect: function redirect(to) {
        if (to.params.lang && to.params.lang.match(/en|ru|ua/)) {
          return '/' + to.params.lang + '/error';
        }

        return '/en/error';
      }
    }]
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.params.lang && !to.params.lang.match(/en|ru|ua/)) {
    next({
      path: '/en/error',
      query: {
        code: 404
        // errors: ['Invalid language']
      }
    });

    return;
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_showdown__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_showdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);




var Converter = new __WEBPACK_IMPORTED_MODULE_1_showdown___default.a.Converter();

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].directive('md', {

  inserted: function inserted(el, binding) {
    var md = binding.value;
    var html = Converter.makeHtml(md);

    el.innerHTML = html;

    var attributes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(el.dataset).filter(function (attr) {
      return attr.match(/^v\-/);
    });
    var elements = el.querySelectorAll('*');

    elements.forEach(function (element) {
      attributes.forEach(function (attr) {
        return element.setAttribute('data-' + attr, '');
      });
    });
  }

});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hammerjs__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('touch', {

  bind: function bind(el, binding) {
    var event = binding.arg;
    // const options = el.hammerOptions

    if (!el.hammer) el.hammer = new __WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a(el);
    if (!event) {
      console.warn('[vue-touch] event type argument is required.');return;
    }
    // if (events.indexOf(event) === -1) { console.warn('[vue-touch] event type argument is invalid.'); return }

    el.hammer.get('swipe').set({ direction: __WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a.DIRECTION_ALL });

    // if (options) el.hammer.set(options)

    el.hammer.on(event, binding.value);
  },

  unbind: function unbind(el) {
    if (el.hammer) {
      el.hammer.destroy();
      el.hammer = null;
    }
  }

});

// Vue.directive('touch-options', {

//   update: (el, binding) => {
//     if (!binding.value) { console.warn('[vue-touch-options] value is required.'); return }

//     el.hammerOptions = binding.value
//   }

// })

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(277)
  __webpack_require__(278)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(471),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25441132",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_the_content__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_the_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_the_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_the_header__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_the_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_the_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_the_menu__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_the_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_the_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_the_popup__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_the_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__layout_the_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_the_loader__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_the_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__layout_the_loader__);
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'App',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_2__layout_wrappers_transition_wrapper___default.a,
    TheContent: __WEBPACK_IMPORTED_MODULE_3__layout_the_content___default.a,
    TheHeader: __WEBPACK_IMPORTED_MODULE_4__layout_the_header___default.a,
    TheMenu: __WEBPACK_IMPORTED_MODULE_5__layout_the_menu___default.a,
    ThePopup: __WEBPACK_IMPORTED_MODULE_6__layout_the_popup___default.a,
    TheLoader: __WEBPACK_IMPORTED_MODULE_7__layout_the_loader___default.a
  },

  created: function created() {
    if (document.getElementsByClassName('loader__content')[0]) {
      document.getElementsByClassName('loader__content')[0].remove();
    }
    this.bindEvents();
    this.setInterceptors();
  },


  computed: {
    isLoading: function isLoading() {
      return this.$store.getters.isLoading;
    }
  },

  watch: {
    '$route.path': 'onRouteChange'
  },

  methods: {
    bindEvents: function bindEvents() {
      var _this = this;

      window.addEventListener('resize', function () {
        var width = window.innerWidth;
        var height = window.innerHeight;

        _this.$store.commit('resize', { width: width, height: height });
      });

      window.addEventListener('scroll', function (event) {
        if (_this.$store.getters.isBlocked) return false;

        var scroll = document.body.scrollTop || document.documentElement.scrollTop;

        _this.$store.commit('scroll', scroll);
      });

      window.addEventListener('DOMMouseScroll', this.onScroll);
      window.addEventListener('mousewheel', this.onScroll);
      window.addEventListener('touchmove', this.onScroll);
      document.body.addEventListener('keydown', this.onKeypress);
      document.addEventListener('click', function () {
        return _this.$root.$emit('click');
      });
    },
    setInterceptors: function setInterceptors() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* api */].interceptors.request.use(function (request) {
        if (request.url && !request.url.match(/\/sitemap/i)) {
          request.headers['Accept-Language'] = _this2.$store.state.app.lang ? _this2.$store.state.app.lang : 'ua';
        }

        // if (request.method && request.method.match(/get/i)) {
        //   this.$store.commit('addRequest')
        // }

        return request;
      }, function (error) {
        // const response = error.response && error.response.config

        // if (response && response.method.match(/get/i)) {
        //   this.$store.commit('removeRequest')
        // }
      });

      __WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* api */].interceptors.response.use(function (response) {
        // if (response.config.method && response.config.method.match(/get/i)) {
        //   this.$store.commit('removeRequest')
        // }
        return response;
      }, function (error) {
        // const response = error.response && error.response.config

        // if (response && response.method.match(/get/i)) {
        //   this.$store.commit('removeRequest')
        // }
      });
    },
    onScroll: function onScroll(event) {
      if (this.$store.getters['app/isBlocked']) {
        event.stopPropagation();
        event.preventDefault();
        event.cancelBubble = false;
        return false;
      }
    },
    onKeypress: function onKeypress(event) {
      this.$root.$emit('keypress', event);
    },
    onRouteChange: function onRouteChange() {
      this.$store.dispatch('closePopup');
      this.$store.routeChangedFromPopup;
    }
  }

});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_url_parser__ = __webpack_require__(212);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'BaseButton',

  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    target: {
      type: String,
      default: 'self'
    },
    white: Boolean
  },

  computed: {
    _url: function _url() {
      return __WEBPACK_IMPORTED_MODULE_0__services_url_parser__["a" /* default */].getUrl(this.url);
    }
  },

  methods: {
    onClick: function onClick(event) {
      if (__WEBPACK_IMPORTED_MODULE_0__services_url_parser__["a" /* default */].isInner(this._url) && !__WEBPACK_IMPORTED_MODULE_0__services_url_parser__["a" /* default */].isMail(this._url)) {
        event.preventDefault();
        this.$router.push(this._url);
      }
    }
  }

});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Dots',

  props: {
    items: {
      type: Array,
      required: true
    },

    current: {
      type: Number,
      required: true
    },

    inverted: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      animating: true
    };
  },


  computed: {
    secondSlide: function secondSlide() {
      return this.$store.state.app.mainPageSecondSlide;
    }
  },

  methods: {
    enter: function enter(el, done) {
      var _this = this;

      var items = this.$refs.items;
      var line = this.$refs.line;

      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();

      tl.fromTo(line, 0.5, {
        scaleX: 0
      }, {
        scaleX: 1,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onStart: function onStart() {
          __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set(line, { autoAlpha: 1 });
          _this.animating = false;
        }
      });

      tl.to(line, 0.5, {
        scaleX: 0,
        onStart: function onStart() {
          return line.style.transformOrigin = 'right';
        },
        onComplete: function onComplete() {
          return line.removeAttribute('style');
        }
      });

      tl.staggerFrom(items, 0.5, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          if (this.target) this.target.removeAttribute('style');
        }
      }, 0.05, '-=0.5', done);
    },
    leave: function leave(el, done) {
      var items = this.$refs.items.reverse();
      var line = this.$refs.line;

      // wtf

      this.animating = true;
      var active = el.querySelector('.list-item.is-active');

      if (active) {
        var dot = active.querySelector('.list-item__dot');
        var label = active.querySelector('.list-item__label');
        dot.style.transitionDelay = '0s';
        dot.style.transitionDuration = '0.25s';
        active.classList.remove('is-active');
        if (label) this.labelLeave(label, function () {});
      }

      // wtf end

      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]();

      tl.fromTo(line, 0.5, {
        scaleX: 0
      }, {
        scaleX: 1,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onStart: function onStart() {
          return __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set(line, { autoAlpha: 1, transformOrigin: 'right' });
        }
      });

      tl.to(line, 0.5, {
        scaleX: 0,
        onStart: function onStart() {
          return __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set(line, { transformOrigin: 'left' });
        },
        onComplete: done
      });

      tl.set(items, {
        autoAlpha: 0
      }, '-=0.5');
    },
    labelEnter: function labelEnter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(el, 0.5, {
        width: 0,
        autoAlpha: 0,
        delay: 1,
        paddingRight: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].set('.list-item:not(.is-active) .list-item__label', {
            width: 0,
            autoAlpha: 0,
            paddingRight: 0
          });
        }
      });
    },
    labelLeave: function labelLeave(el, done) {
      var duration = this.animating ? 0.25 : 0.5;
      var delay = this.animating ? 0 : 0.5;

      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(el, duration, {
        width: 0,
        delay: delay,
        autoAlpha: 0,
        paddingRight: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      });
    }
  }

});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ScrollMarker',

  props: {
    label: {
      type: String,
      default: function _default() {
        return this.$t('scroll-deeper');
      }
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      standby: false,
      timeout: null
    };
  },


  methods: {
    onClick: function onClick() {
      this.$emit('click');
    },
    beforeAppear: function beforeAppear(el) {
      this.$refs.label.style.transition = 'none';
      this.$refs.bar.style.transition = 'none';
      this.$refs.arrow.style.transition = 'none';
      this.$refs.arrowTip.style.transition = 'none';

      this.$refs.arrow.style.opacity = 1;
      this.$refs.arrow.style.visibility = 'visible';
      this.$refs.arrow.style.transform = 'scale(1)';
      this.$refs.arrow.style.height = '0';

      this.$refs.arrowTip.style.opacity = 1;
      this.$refs.arrowTip.style.visibility = 'visible';
    },
    enter: function enter(el, done) {
      var _this = this;

      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      clearTimeout(this.timeout);

      var line = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({
        delay: params.delay || 0,
        onComplete: function onComplete() {
          if (_this.$refs.bar) _this.$refs.bar.removeAttribute('style');
          if (_this.$refs.arrow) _this.$refs.arrow.removeAttribute('style');
          if (_this.$refs.arrowTip) _this.$refs.arrowTip.removeAttribute('style');
          if (_this.$refs.label) _this.$refs.label.removeAttribute('style');

          _this.timeout = setTimeout(function () {
            _this.standby = true;
            _this.timeout = null;
            clearTimeout(_this.timeout);
          }, 100);

          done();
        }
      });

      line.fromTo(this.$refs.arrowTip, 0.25, {
        scale: 0,
        y: -12
      }, {
        scale: 1,
        delay: 0.25,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onStart: function onStart() {
          if (this.target) {
            this.target.style.transformOrigin = 'top';
          }
        }
      });

      line.fromTo(this.$refs.bar, 0.1, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, '+=0.2');

      line.add('before-slide');

      line.fromTo(this.$refs.bar, 0.35, {
        height: 0
      }, {
        height: 52,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 'before-slide');

      line.to(this.$refs.arrowTip, 0.35, {
        y: 40,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 'before-slide');

      line.fromTo(this.$refs.bar, 0.35, {
        y: -20
      }, {
        y: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power2"].easeOut
      }, 'before-slide+=0.3');

      line.from(this.$refs.label, 0.4, {
        autoAlpha: 0,
        y: -10,
        scale: 1.2,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power2"].easeOut,
        onStart: function onStart() {
          if (this.target) {
            this.target.style.transformOrigin = 'bottom';
          }
        }
      }, '-=0.2');
    },


    // enter (el, done) {
    //   this.standby = true

    //   Tween.from(el, 1, {
    //     autoAlpha: 0,
    //     ease: Power1.easeOut,
    //     onComplete: done
    //   })
    // },

    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(el, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: done
      });
    }
  }

});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//




var IS_FIREFOX = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
var IS_MAC = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
var MOUSEWHEEL = IS_FIREFOX ? 'DOMMouseScroll' : 'mousewheel';

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Scroller',

  props: {
    threshold: {
      type: Number,
      default: 150
    },
    block: {
      type: Boolean,
      default: false
    },
    global: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      enabled: false,
      timer: null,
      lastDelta: 0,
      lastTime: 0,
      lastDiff: 0,
      lastInitialScroll: 0
    };
  },


  computed: {
    onSlideDebounced: function onSlideDebounced() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (callback) {
        callback();
      }, this.threshold, { leading: true, trailing: false });
    }
  },

  created: function created() {
    this.$on('enable', this.enable);
    this.$on('disable', this.disable);
  },
  mounted: function mounted() {
    //scroller off
    this.enable();
  },
  beforeDestroy: function beforeDestroy() {
    this.$off();
    this.disable();
  },


  methods: {
    enable: function enable() {
      if (this.global) {
        document.addEventListener(MOUSEWHEEL, this.onScroll);
      } else {
        this.$el.addEventListener(MOUSEWHEEL, this.onScroll);
      }

      this.enabled = true;
    },
    disable: function disable() {
      if (this.global) {
        document.removeEventListener(MOUSEWHEEL, this.onScroll);
      } else {
        this.$el.removeEventListener(MOUSEWHEEL, this.onScroll);
      }

      this.enabled = false;
    },
    onScroll: function onScroll(event) {
      var _this = this;

      event.preventDefault();

      var delta = 0;

      if (!event) event = window.event;

      if (event.wheelDelta) {
        delta = event.wheelDelta / 120;
      } else if (event.detail) {
        delta = -event.detail / 3;
      }

      delta = delta.toFixed(2);

      var threshold = IS_FIREFOX ? 300 : 50;
      var isFiredFast = event.timeStamp - this.lastTime < threshold;
      var isDecreasing = Math.abs(delta) <= Math.abs(this.lastDelta);
      var isDifferenceThrustful = event.timeStamp - this.lastInitialScroll > threshold && Math.abs(delta) - Math.abs(this.lastDelta) > 0.5;
      var isInitialScroll = !(isFiredFast && isDecreasing) && isDifferenceThrustful;

      console.log(event.timeStamp - this.lastInitialScroll > threshold && Math.abs(delta) - Math.abs(this.lastDelta) > 0.5);

      if (isInitialScroll) {
        console.log('initial scroll');
        var direction = delta - this.lastDelta <= 0;
        this.onInitialScroll(direction);
      }

      this.lastDelta = delta;
      this.lastDiff = (event.timeStamp - this.lastTime).toFixed(2);
      this.lastTime = event.timeStamp;

      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(function () {
        _this.lastDelta = 0;
        clearTimeout(_this.timer);
        _this.timer = null;
      }, 30);
    },


    /**
     * @param      {<bollean>}  direction  If true - scroll goes down
     */
    onInitialScroll: function onInitialScroll(direction) {
      this.$emit('scroll', direction);

      if (!this.block) {
        this.onSlide(direction);
      }
    },
    onSlide: function onSlide(direction) {
      var _this2 = this;

      this.onSlideDebounced(function () {
        _this2.$emit('slide', direction);

        if (direction) {
          _this2.$emit('slide-down');
        } else {
          _this2.$emit('slide-up');
        }
      });
    }
  }

});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "slide",

  props: {
    indexSlide: {
      type: Number,
      default: null
    }
  },

  data: function data() {
    return {};
  },


  methods: {
    getSlideIndex: function getSlideIndex() {
      this.$emit('slideClick', this.indexSlide);
    }
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_slider_slide__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_slider_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_slider_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dots__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_dots__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper__);
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({

  name: "sliderMain",

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper___default.a,
    Dots: __WEBPACK_IMPORTED_MODULE_4__components_dots___default.a,
    Slide: __WEBPACK_IMPORTED_MODULE_3__components_slider_slide___default.a
  },

  props: {
    slideList: {
      type: Array,
      default: null
    },
    block: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      currentSlide: 0,
      binded: {}
    };
  },
  mounted: function mounted() {
    this.getOffset();
    this.binded.onKeypress = this.onKeypress.bind(this);
    document.body.addEventListener('keydown', this.binded.onKeypress);
  },
  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('keydown', this.binded.onKeypress);
  },


  computed: {
    slides: function slides() {
      var _this = this;

      var slides = this.$store.state.app.meta.pages;
      var filtered = slides.filter(function (slide) {
        return !slide.url.match(/main/);
      });

      var current = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(filtered, function (slide) {
        return !!_this.$route.path.match(new RegExp(slide.url));
      });

      if (current === -1) return filtered;

      var sorted = filtered.concat(filtered.splice(0, current + 1));

      return sorted.filter(function (slide) {
        return !_this.$route.path.match(new RegExp(slide.url));
      });
    },
    lang: function lang() {
      return this.$route.params.lang ? this.$route.params.lang : 'ua';
    }
  },

  watch: {
    '$store.state.app.window.width': 'getOffset',
    'offset': 'setActiveSlide',
    'currentSlide': 'setActiveSlide'
  },

  methods: {
    isActive: function isActive() {
      var bb = this.$el.getBoundingClientRect();
      var hook = bb.bottom - this.$store.state.app.window.height;
      var scroll = $store.state.app.window.scroll;

      return hook < bb.height / 3;
    },


    getSlideIndex: function getSlideIndex() {
      this.$emit('slideClick', this.indexSlide);
    },

    onKeypress: function onKeypress(event) {
      if (!this.isActive) return;

      if (event.keyCode === 37) this.prevSlide();
      if (event.keyCode === 39) this.nextSlide();
      if (event.keyCode === 13) {
        this.$router.push('/' + this.lang + this.slides[this.currentSlide].url);
      }
    },
    scrollUp: function scrollUp() {
      if (!this.block) this.$emit('scroll-up');
    },
    prevSlide: function prevSlide() {
      if (!this.isActive) return;

      if (this.currentSlide === 0) {
        var height = this.$el.offsetHeight;
        var scroll = this.$store.state.app.window.scroll - height;

        __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(window, 0.5, {
          scrollTo: scroll,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power1"].easeInOut
        });

        this.scrollUp();
      }

      if (this.block) return;

      this.currentSlide = Math.max(this.currentSlide - 1, 0);
    },


    nextSlide: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      if (!this.isActive || this.block) return;

      this.currentSlide = Math.min(this.currentSlide + 1, this.slides.length - 1);
    }, 400, { leading: true, trailing: false }),

    getOffset: function getOffset() {
      this.offset = parseInt(getComputedStyle(this.$refs.slides[0].$el).marginLeft);
    },
    setActiveSlide: function setActiveSlide() {
      var slide = this.$refs.slides[this.currentSlide];
      var offset = slide.$el.offsetLeft - this.offset;

      __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].to(this.$refs.track, 0.5, {
        x: -offset,
        overwrite: 'all',
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power1"].easeInOut
      });
    },
    setSlide: function setSlide(data) {
      this.currentSlide = data;
    }
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'widget-mixin',

  props: {
    $content: [Object, String]
  }

});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Burger',

  computed: {
    isPopupOpened: function isPopupOpened() {
      return this.$store.getters.isPopupOpened;
    }
  },

  methods: {
    toggleMenu: function toggleMenu() {
      if (this.$store.getters.isPopupAnimating) return;

      if (!this.$store.getters.isPopupOpened) {
        this.$store.dispatch('openPopup', 'menu');
      } else {
        this.$store.dispatch('closePopup');
      }
    }
  }

});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'LangSwitcher',

  data: function data() {
    return {
      opened: false,
      langs: [{ id: 'ua', label: 'ukr' }, { id: 'en', label: 'eng' }]
    };
  },


  computed: {
    currentLang: function currentLang() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(this.langs, { id: this.$store.state.app.lang });
    },
    availableLangs: function availableLangs() {
      var _this = this;

      return this.langs.filter(function (lang) {
        return lang.id !== _this.currentLang.id;
      });
    },
    isMobile: function isMobile() {
      return this.$store.getters.isMobile;
    },
    menuOpenMobile: function menuOpenMobile() {
      return this.$store.getters.isPopupOpened && this.isMobile;
    }
  },

  created: function created() {
    var _this2 = this;

    this.$root.$on('click', function () {
      return _this2.opened = false;
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('click');
  },


  methods: {
    getLangUrl: function getLangUrl(newLang) {
      var route = this.$route;

      if (route.name === 'home') return '/' + newLang;

      var lang = route.params.lang;
      var path = route.fullPath;
      var url = path.replace(new RegExp('/' + lang), '/' + newLang);

      return url;
    },
    onLangChange: function onLangChange() {
      this.$store.commit('startLoading', true);

      this.opened = false;

      if (this.$store.getters.isPopupOpened) {
        this.$store.dispatch('closePopup', true);
      }
    }
  }

});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


// import logoWhite from '@/assets/aurocraft-logo.svg'
// import logoBlack from '@/assets/aurocraft-logo-dark.svg'
// import logoBlack from '@/assets/aurocraft-logo-orange.svg'

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Logo',

  props: {
    mode: {
      type: String,
      default: 'white',
      validator: function validator(value) {
        return value.match(/^white|black$/);
      }
    }
  },

  computed: {
    logo: function logo() {
      return this.mode === 'white' ? logoWhite : logoBlack;
    },
    lang: function lang() {
      return this.$route.params.lang ? this.$route.params.lang : '';
    },
    isMobile: function isMobile() {
      return this.$store.getters.isMobile;
    },
    menuOpenMobile: function menuOpenMobile() {
      return this.$store.getters.isPopupOpened && this.isMobile;
    }
  },

  methods: {
    onLinkClick: function onLinkClick() {
      if (this.$store.getters.isPopupOpened) {
        this.$store.dispatch('closePopup', true);
      }
    }
  }

});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__);



var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TheContent',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default.a
  },

  computed: {
    test: function test() {
      return this.$store.getters.loaderText[0].value;
    },
    isLoading: function isLoading() {
      return this.$store.getters.isLoading;
    },
    pageMeta: function pageMeta() {
      var _this = this;

      if (this.$route.name === 'home') return this.$store.getters.pages.filter(function (item, index) {
        return item.url === '/main';
      })[0];

      return this.$store.getters.pages.filter(function (item, index) {
        return item.url === '/' + _this.$route.name;
      })[0];
    }
  },

  watch: {
    'title': 'setTitle'
  },

  beforeRouteEnter: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var lang;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              lang = to.name === 'home' && !to.params.lang ? 'ua' : to.params.lang;


              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setLanguage', lang);

              if (__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.localeExists(lang)) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('fetchMeta', lang);

            case 5:

              next();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),

  beforeRouteUpdate: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
      var lang;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(from.params.lang === to.params.lang)) {
                _context2.next = 3;
                break;
              }

              next();
              return _context2.abrupt('return');

            case 3:

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('startLoading', true);

              lang = to.name === 'home' && !to.params.lang ? 'ua' : to.params.lang;


              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('setLanguage', lang);

              _context2.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('fetchMeta', lang);

            case 8:

              next();

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function beforeRouteUpdate(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }()

});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scroller__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_slider_slider__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_slider_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_slider_slider__);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TheFooter',

  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_2__components_slider_slider___default.a
  },

  data: function data() {
    return {
      social: ['facebook', 'behance', 'instagram']
    };
  },


  computed: {
    slides: function slides() {
      var _this = this;

      var slides = this.$store.state.app.meta.pages;
      var filtered = slides.filter(function (slide) {
        return !slide.url.match(/main/);
      });

      var current = __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(filtered, function (slide) {
        return !!_this.$route.path.match(new RegExp(slide.url));
      });

      if (current === -1) return filtered;

      var sorted = filtered.concat(filtered.splice(0, current + 1));

      return sorted.filter(function (slide) {
        return !_this.$route.path.match(new RegExp(slide.url));
      });
    }
  }

});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_logo__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__elements_logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_lang_switcher__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_lang_switcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__elements_lang_switcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_burger__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_burger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__elements_burger__);
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TheHeader',

  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_1__elements_logo___default.a,
    LangSwitcher: __WEBPACK_IMPORTED_MODULE_2__elements_lang_switcher___default.a,
    Burger: __WEBPACK_IMPORTED_MODULE_3__elements_burger___default.a
  },

  computed: {
    isDesktop: function isDesktop() {
      return this.$store.getters['window'].width > 1023;
    },
    isMobile: function isMobile() {
      return this.$store.getters['window'].width > 768;
    },
    isHomepage: function isHomepage() {
      return !!(this.$route.name && this.$route.name.match(/home/));
    },
    isInner: function isInner() {
      return !!(this.$route.name && this.$route.name.match(/project$|story$|error/));
    },
    pageName: function pageName() {
      if (!this.$route.name || this.$route.name.match(/error|not-found/)) return null;

      if (this.$route.name.match(/project$|story$/)) {
        return this.$store.state.pages.inners[this.$route.params.slug].name;
      }

      return this.$store.state.pages.landings[this.$route.name].name;
    },
    state: function state() {
      if (this.isPopupOpened) return 'is-default';

      var isShort = this.$route.name && (!!this.$route.name.match(/about/) || !!this.$route.name.match(/home/) && this.$store.state.app.mainPageIntroSlide);

      return isShort ? 'is-short' : 'is-default';
    },
    isPopupOpened: function isPopupOpened() {
      return this.$store.getters.isPopupOpened;
    },
    isLoading: function isLoading() {
      return this.$store.getters.isLoading;
    },
    isLogoInverted: function isLogoInverted() {
      if (this.state === 'is-fixed') return false;

      if (this.isLoading) return false;
      if (this.isPopupOpened) return true;

      //      if(this.$store.state.app.mainPageSecondSlide) return false

      if (this.$route.name && this.$route.name.match(/home/) && this.$store.state.app.mainPageLastSlide) {
        var _$store$getters$windo = this.$store.getters['window'],
            width = _$store$getters$windo.width,
            height = _$store$getters$windo.height;


        if (width >= 768 && height < 770) return false;
        if (width < 768 && height < 520) return false;
      }

      if (this.$route.name && this.$route.name.match(/home|about/)) return true;

      return false;
    },
    isMenuInverted: function isMenuInverted() {
      if (this.state === 'is-fixed') return false;

      if (this.isLoading) return false;
      if (this.isPopupOpened) return true;

      //      if(this.$store.state.app.mainPageSecondSlide) return false

      if (this.$route.name && this.$route.name.match(/home/) && this.$store.state.app.mainPageLastSlide) {
        var _$store$getters$windo2 = this.$store.getters['window'],
            width = _$store$getters$windo2.width,
            height = _$store$getters$windo2.height;


        if (width >= 768 && height < 770) return false;
        if (width < 768 && height < 520) return false;
      }

      if (this.$route.name && this.$route.name.match(/home|about/)) return true;
      if (this.$route.name && this.$route.name.match(/contacts/) && this.$store.state.app.window.width > 1024) return true;

      return false;
    }
  },

  methods: {
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(el, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: done
      });
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(el, 0.5, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: done
      });
    }
  }

});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__layout_wrappers_transition_wrapper__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TheLoader',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_1__layout_wrappers_transition_wrapper___default.a
  },

  methods: {
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(el, 1, {
        autoAlpha: 0,
        onComplete: done
      });
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(el, 1, {
        autoAlpha: 0,
        onComplete: done
      });
    }
  }

});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_social_facebook_logo_svg__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_social_facebook_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_social_facebook_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_social_instagram_logo_svg__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_social_instagram_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_social_instagram_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_social_behance_logo_svg__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_social_behance_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_social_behance_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);

//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TheMenu',

  data: function data() {
    return {
      social: [{ image: __WEBPACK_IMPORTED_MODULE_1__assets_social_facebook_logo_svg___default.a, name: 'facebook' }, { image: __WEBPACK_IMPORTED_MODULE_2__assets_social_instagram_logo_svg___default.a, name: 'instagram' }, { image: __WEBPACK_IMPORTED_MODULE_3__assets_social_behance_logo_svg___default.a, name: 'behance' }]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    lang: function lang() {
      return this.$route.params.lang ? this.$route.params.lang : 'ua';
    },
    links: function links() {
      return this.$store.state.app.meta.pages.filter(function (page) {
        return !page.url.match(/main/);
      });
    },
    gridSize: function gridSize() {
      return this.links.length <= 6 ? this.links.length <= 4 ? 'is-2' : 'is-3' : 'is-4';
    }
  }, 'lang', function lang() {
    return this.$route.params.lang ? this.$route.params.lang : 'ua';
  }),

  methods: {
    onLinkClick: function onLinkClick() {
      if (this.$store.getters.isPopupOpened) {
        this.$store.dispatch('closePopup', true);
      }
    },
    enter: function enter(el, done) {
      var wHeight = this.$store.state.app.window.height;

      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].from(this.$refs.bg, 0.5, {
        y: -wHeight,
        ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut
      });

      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].staggerFrom(this.$refs.links, 0.2, {
        autoAlpha: 0,
        delay: 0.2
      }, 0.1);

      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].staggerFrom(this.$refs.social, 0.2, {
        autoAlpha: 0,
        delay: 0.4
      }, 0.05, done);
    },
    leave: function leave(el, done) {
      var wHeight = this.$store.state.app.window.height;

      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(this.$refs.content, 0.1, {
        autoAlpha: 0
      });

      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(this.$refs.bg, 0.5, {
        y: wHeight,
        ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          done();
        }
      });
    }
  }

});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_the_menu__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_the_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__layout_the_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_contacts_feedback_form__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_contacts_feedback_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_contacts_feedback_form__);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ThePopup',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_0__layout_wrappers_transition_wrapper___default.a,
    FeedbackForm: __WEBPACK_IMPORTED_MODULE_2__pages_contacts_feedback_form___default.a,
    TheMenu: __WEBPACK_IMPORTED_MODULE_1__layout_the_menu___default.a
  },

  computed: {
    isMenuOpened: function isMenuOpened() {
      return this.$store.state.menu.opened;
    },
    isFormOpened: function isFormOpened() {
      return this.$store.state.form.opened;
    },
    isPopupOpened: function isPopupOpened() {
      return this.$store.getters.isPopupOpened;
    }
  },

  methods: {
    onAnimationStart: function onAnimationStart() {
      this.$store.commit('popupAnimationStart');
    },
    onAnimationEnd: function onAnimationEnd() {
      this.$store.commit('popupAnimationEnd');
    }
  }

});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'AppearanceWrapper',

  data: function data() {
    return {
      visible: false,
      hook: 0.5
    };
  },


  computed: {
    height: function height() {
      return this.$store.state.app.window.height;
    },
    child: function child() {
      return this.$children.length > 0 ? this.$children[0] : null;
    }
  },

  watch: {
    '$store.state.app.window.scroll': 'onScroll'
  },

  mounted: function mounted() {
    var _this = this;

    this.prepare();
    this.$nextTick(function () {
      _this.onScroll();
    });
  },


  methods: {
    onScroll: function onScroll() {
      if (this.visible || !this.child) return;

      var bb = this.child.hasOwnProperty('getBoundingClientRect') ? this.child.getBoundingClientRect() : this.child.$el.getBoundingClientRect();

      var visible = bb.top <= this.height * this.hook;

      if (visible) {
        this.visible = visible;
        this.animate();
      }
    },
    prepare: function prepare() {
      if (this.child.hasOwnProperty('beforeAppear')) {
        this.child.beforeAppear();
      }
    },
    animate: function animate() {
      if (this.child.hasOwnProperty('appear')) {
        this.child.appear();
      }
    }
  }

});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TransitionWrapper',

  props: {
    appear: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },

    appearDelay: {
      type: [Number, String],
      default: 0
    },

    beforeAppearTransition: {
      type: Function,
      default: null
    },
    appearTransition: {
      type: Function,
      default: null
    },
    beforeEnterTransition: {
      type: Function,
      default: null
    },
    enterTransition: {
      type: Function,
      default: null
    },
    beforeLeaveTransition: {
      type: Function,
      default: null
    },
    leaveTransition: {
      type: Function,
      default: null
    }
  },

  methods: {
    beforeAppear: function beforeAppear(el) {
      if (!this.$children.length) return;

      var child = this.$children[0];

      if (child.hasOwnProperty('beforeAppear')) {
        child.beforeAppear(child.$el);
      } else if (child.hasOwnProperty('beforeEnter')) {
        child.beforeEnter(child.$el);
      } else if (this.beforeAppearTransition) {
        this.beforeAppearTransition(child.$el);
      }
    },
    appear_: function appear_(el, done) {
      var _this = this;

      if (!this.$children.length) return;

      var child = this.$children[0];

      if (child.hasOwnProperty('appear')) {

        this.$emit('transition-start');
        child.appear(child.$el, function () {
          _this.$emit('transition-end');
          done();
        }, { delay: this.appearDelay });
      } else if (child.hasOwnProperty('enter')) {

        this.$emit('transition-start');
        child.enter(child.$el, function () {
          _this.$emit('transition-end');
          done();
        });
      } else if (this.appearTransition) {
        this.appearTransition(child.$el, done);
      } else {
        done();
      }
    },
    beforeEnter: function beforeEnter(el) {
      if (!this.$children.length) return;

      var child = this.$children[0];

      if (child.hasOwnProperty('beforeEnter')) {
        child.beforeEnter(child.$el);
      } else if (this.beforeEnterTransition) {
        this.beforeEnterTransition(child.$el);
      }
    },
    enter: function enter(el, done) {
      var _this2 = this;

      if (!this.$children.length) return;

      var child = this.$children[0];

      if (child.hasOwnProperty('enter')) {

        this.$emit('transition-start');
        child.enter(child.$el, function () {
          _this2.$emit('transition-end');
          done();
        });
      } else if (this.enterTransition) {
        this.enterTransition(child.$el, done);
      } else {
        done();
      }
    },
    beforeLeave: function beforeLeave(el) {
      if (!this.$children.length) return;

      var child = this.$children[0];

      if (child.hasOwnProperty('beforeLeave')) {
        child.beforeLeave(child.$el);
      } else if (this.beforeLeaveTransition) {
        this.beforeLeaveTransition(child.$el);
      }
    },
    leave: function leave(el, done) {
      var _this3 = this;

      if (!this.$children.length) return;

      var child = this.$children[0];

      if (child.hasOwnProperty('leave')) {

        this.$emit('transition-start');
        child.leave(child.$el, function () {
          _this3.$emit('transition-end');
          done();
        });
      } else if (this.leaveTransition) {
        this.leaveTransition(child.$el, done);
      } else {
        done();
      }
    }
  }

});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widget__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_base_button__);

//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'awards-widget',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_widget___default.a],

  components: {
    BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_button___default.a
  },

  data: function data() {
    return {
      tl: null
    };
  },


  filters: {
    getYear: function getYear(timestamp) {
      return new Date(timestamp).getFullYear();
    }
  },

  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({ paused: true });

      tl.from(this.$refs.background, 1, {
        scaleX: 0,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
      });

      var group = [this.$refs.title];

      if (this.$refs.items) group.push.apply(group, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$refs.items));

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
      }, 0.05, '-=0.25');
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widget__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_widget__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'DescriptionWidget',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_widget___default.a],

  data: function data() {
    return {
      tl: null
    };
  },


  computed: {
    mainContent: function mainContent() {
      return this.$content.main;
    },
    asideContent: function asideContent() {
      return this.$content.aside;
    }
  },

  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });

      tl.from(this.$refs.asideBg, 1, {
        scaleY: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      });

      tl.from(this.$refs.asideGraphic, 0.5, {
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.1);

      tl.from(this.$refs.asideContent, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.5);

      tl.from(this.$refs.mainContent, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.5);
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_wrappers_appearance_wrapper__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_wrappers_appearance_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__layout_wrappers_appearance_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scroll_marker__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_scroll_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_scroll_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__description__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__description__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partners__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__partners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__partners__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__awards__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__awards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__awards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_the_footer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_the_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__layout_the_footer__);



var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'AboutPage',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_5__layout_wrappers_transition_wrapper___default.a,
    AppearanceWrapper: __WEBPACK_IMPORTED_MODULE_6__layout_wrappers_appearance_wrapper___default.a,
    ScrollMarker: __WEBPACK_IMPORTED_MODULE_7__components_scroll_marker___default.a,
    Description: __WEBPACK_IMPORTED_MODULE_8__description___default.a,
    Partners: __WEBPACK_IMPORTED_MODULE_9__partners___default.a,
    Awards: __WEBPACK_IMPORTED_MODULE_10__awards___default.a,
    TheFooter: __WEBPACK_IMPORTED_MODULE_11__layout_the_footer___default.a
  },

  computed: {
    $content: function $content() {
      return this.$store.state.pages.landings.about;
    },
    $description: function $description() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(this.$content.widgets, { type: 'Description' });
    },
    $partners: function $partners() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(this.$content.widgets, { type: 'BoxList' });
    },
    $awards: function $awards() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(this.$content.widgets, { type: 'List' });
    }
  },

  beforeRouteEnter: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var page;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('startLoading');
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchLanding', 'about');

            case 3:
              page = _context.sent;

              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('endLoading');
              next();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),

  beforeRouteUpdate: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
      var page;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(from.params.lang === to.params.lang)) {
                _context2.next = 3;
                break;
              }

              next();
              return _context2.abrupt('return');

            case 3:

              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('startLoading');
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchLanding', 'about');

            case 6:
              page = _context2.sent;

              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('endLoading');
              next();

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function beforeRouteUpdate(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),

  created: function created() {
    this.setTitle();
  },


  methods: {
    setTitle: function setTitle() {
      var title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },
    enter: function enter(el, done) {
      var tl = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]({ onComplete: function onComplete() {
          return done;
        } });

      tl.from(this.$refs.background, 1, {
        y: -65,
        scaleY: 0,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut
      });

      tl.from(this.$refs.content, 1, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut
      }, 0.1);

      if (this.$refs.image) {
        tl.from(this.$refs.image, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut
          // onUpdate: () => {
          //   const y = this.$refs.image.style.opacity * 100

          //   Tween.set(this.$refs.image, {
          //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
          //   })
          // }
        });

        // tl.from(this.$refs.image, 1, {
        //   autoAlpha: 0,
        //   ease: Power1.easeOut
        // })
      }
    },
    leave: function leave(el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done();
      } else {
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(el, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut,
          onComplete: done
        });
      }
    },
    scroll: function scroll() {
      var bb = this.$refs.description.$el.getBoundingClientRect();

      var offset = bb.top - (this.$store.state.app.window.height - bb.height) / 2;
      var scroll = this.$store.state.app.window.scroll + offset;

      __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(window, 1, {
        scrollTo: scroll,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeInOut
      });
    }
  }

});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widget__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_base_button__);

//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PartnersWidget',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__components_widget___default.a],

  components: {
    BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_button___default.a
  },

  data: function data() {
    return {
      tl: null
    };
  },


  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({ paused: true });

      var els = [this.$refs.heading, this.$refs.subheading, this.$refs.aside].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$refs.items));

      tl.staggerFrom(els, 1, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
      }, 0.05);
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dots__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_dots__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_base_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_imask__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_imask__);


//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'FeedbackForm',

  components: {
    BaseButton: __WEBPACK_IMPORTED_MODULE_6__components_base_button___default.a,
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default.a,
    Dots: __WEBPACK_IMPORTED_MODULE_5__components_dots___default.a
  },

  data: function data() {
    return {
      visible: false,
      sending: false,
      invalid: false,
      failed: false,
      currentStep: 1
    };
  },


  computed: {
    widget: function widget() {
      var contactsPage = this.$store.state.pages.landings.contacts;
      var widget = contactsPage.contacts;

      return widget;
    },
    action: function action() {
      return this.widget.action;
    },
    steps: function steps() {
      return this.widget.steps;
    },
    formData: function formData() {
      return this.$store.state.form.formData;
    }
  },

  created: function created() {
    this.$store.commit('form/reset');
    this.$root.$on('keypress', this.onKeypress);
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off();
  },


  methods: {
    onKeypress: function onKeypress(event) {
      if (event.keyCode === 27) {
        this.$store.dispatch('closePopup');
      }
    },
    update: function update(event) {
      this.invalid = false;

      var input = event.target;
      var key = input.getAttribute('data-id');
      var value = input.value;

      this.$store.commit('form/updateField', { key: key, value: value });

      this.validate();
    },
    enter: function enter(el, done) {
      var _this = this;

      setTimeout(function () {
        _this.visible = true;
        done();
      }, 500);
    },
    closeThankYou: function closeThankYou() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$store.dispatch('closePopup');
      }, 10000);
    },
    stepEnter: function stepEnter(el, done) {
      var _this3 = this;

      var primary = el.querySelector('[data-primary]');
      var secondary = el.querySelector('[data-secondary]');

      window.secondary = secondary;
      __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].staggerFrom([primary, secondary], 2.5, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power1"].easeOut,
        onStart: function onStart() {
          if (secondary.tagName.match(/input/i)) {
            secondary.focus();

            var key = secondary.getAttribute('data-id');

            if (_this3.formData.hasOwnProperty(key)) {
              secondary.value = _this3.formData[key];
            }

            _this3.update({ target: secondary });
          }
        },
        onComplete: function onComplete() {
          if (secondary.tagName.match(/input/i)) secondary.focus();
        }
      }, 0.05, done);

      var phoneInput = document.querySelector('input[type="phone"]');

      if (phoneInput) {
        new __WEBPACK_IMPORTED_MODULE_7_imask___default.a(phoneInput, {
          mask: '+{38} 000 000 00 00',
          lazy: false,
          placeholderChar: ' ',
          commit: function commit(value, masked) {
            value;
          }
        });
      }

      if (this.currentStep - 1 === this.steps.length) {
        this.closeThankYou();
      }
    },
    stepLeave: function stepLeave(el, done) {
      var primary = el.querySelector('[data-primary]');
      var secondary = el.querySelector('[data-secondary]');

      __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"].staggerTo([primary, secondary], 0.5, {
        autoAlpha: 0,
        y: 40,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power1"].easeOut
      }, 0.05, done);
      done();
    },
    onBlur: function onBlur() {
      var input = this.$el.querySelector('.step__input');

      if (input && this.currentStep < this.steps.length) {
        input.focus();
      }
    },
    prevStep: function prevStep() {
      this.currentStep = Math.max(this.currentStep - 1, 1);
    },
    nextStep: function nextStep() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.validate()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (!(_this4.currentStep !== _this4.steps.length)) {
                  _context.next = 5;
                  break;
                }

                _this4.currentStep = Math.min(_this4.currentStep + 1, _this4.steps.length + 1);
                return _context.abrupt('return');

              case 5:
                _context.prev = 5;

                _this4.sending = true;
                _this4.currentStep = Math.min(_this4.currentStep + 1, _this4.steps.length + 1);

                _context.next = 10;
                return _this4.$store.dispatch('form/send', 'get');

              case 10:
                result = _context.sent;


                if (!result) {
                  _this4.failed = true;
                }

                _this4.sending = false;
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](5);

                _this4.failed = true;
                _this4.sending = false;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[5, 15]]);
      }))();
    },
    validate: function validate() {
      var input = this.$refs.input[0];
      var type = input.getAttribute('type');
      var value = input.value;
      // const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i
      //      const emailPattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i
      var emailPattern = /^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+[\.]+[a-zA-Z0-9]+(?:\.[a-zA-Z0-9-]+)*$/i;
      // const phonePattern = /^[0-9+\-() ]+$/i
      var phonePattern = value.replace(/\s/g, '');

      if (!input) return true;

      if (value.length <= 0) {
        this.invalid = true;
        return false;
      }

      if (type === 'email' && !emailPattern.test(value)) {
        this.invalid = true;
        return false;
      }

      if (type === 'phone' && phonePattern.length < 13) {
        this.invalid = true;
        return false;
      }

      return true;
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_base_button__);




var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ContactsPage',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_6__layout_wrappers_transition_wrapper___default.a,
    BaseButton: __WEBPACK_IMPORTED_MODULE_7__components_base_button___default.a
  },

  computed: {
    isFormOpened: function isFormOpened() {
      return this.$store.state.form.opened;
    },
    $content: function $content() {
      return this.$store.state.pages.landings.contacts;
    },
    contacts: function contacts() {
      return this.$content.address;
    },
    formData: function formData() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(this.$content.contacts);
    },
    windowWidth: function windowWidth() {
      return this.$store.state.app.window.width;
    }
  },

  created: function created() {
    if (this.contacts === undefined || this.formData === undefined) {
      this.$router.push('/not-found');
    }
    this.setTitle();
  },


  beforeRouteEnter: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var page, errors;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('startLoading');

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('pages/fetchLanding', 'contacts');

            case 3:
              page = _context.sent;
              errors = [];


              if (!page.contacts) errors.push('Contacts page must have a contacts widget.2');

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('endLoading');

              if (!(errors.length > 0)) {
                _context.next = 10;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context.abrupt('return');

            case 10:

              next();

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),

  beforeRouteUpdate: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
      var page, errors;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(from.params.lang === to.params.lang)) {
                _context2.next = 3;
                break;
              }

              next();
              return _context2.abrupt('return');

            case 3:

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('startLoading');

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('pages/fetchLanding', 'contacts');

            case 6:
              page = _context2.sent;
              errors = [];

              if (!page.contacts) errors.push('Contacts page must have a contacts widget.');

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('endLoading');

              if (!(errors.length > 0)) {
                _context2.next = 13;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context2.abrupt('return');

            case 13:

              next();

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function beforeRouteUpdate(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),

  methods: {
    setTitle: function setTitle() {
      var title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },
    enter: function enter() {
      var tl = new __WEBPACK_IMPORTED_MODULE_4_gsap__["TimelineMax"]();

      //for forms
      //      tl.from(this.$refs.background, 1, {
      //        scaleY: 0,
      //        ease: Power1.easeOut
      //      })
      //
      //      tl.from(this.$refs.button, 1, {
      //        autoAlpha: 0,
      //        y: -40,
      //        ease: Power1.easeOut,
      //        onStart: () => {
      //          if (this.$refs.button) {
      //            this.$refs.button.setAttribute('disabled', true)
      //          }
      //        },
      //        onComplete: () => {
      //          if (this.$refs.button) {
      //            this.$refs.button.removeAttribute('style')
      //            this.$refs.button.removeAttribute('disabled')
      //          }
      //        }
      //      }, 0.4)
      //end forms

      var els = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$refs.contacts));

      tl.staggerFrom(els, 1, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut
      }, 0.1, 0.5);
    },
    leave: function leave(el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(el, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut,
          onComplete: done
        });
      }
    },
    openForm: function openForm() {
      this.$store.dispatch('openPopup', 'form');
    }
  }

});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_base_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ErrorPage',

  components: {
    BaseButton: __WEBPACK_IMPORTED_MODULE_2__components_base_button___default.a
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('endLoading');
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('endLoading');
    next();
  },
  created: function created() {
    this.setTitle();
  },


  computed: {
    code: function code() {
      return this.$route.query.code ? this.$route.query.code : 404;
    },
    message: function message() {
      return parseInt(this.code) === 404 ? this.$t('page-not-found') : this.$t('server-error');
    },
    errors: function errors() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.$route.query.errors) === 'object' ? this.$route.query.errors : [this.$route.query.errors];
    }
  },

  methods: {
    setTitle: function setTitle() {
      var title = document.getElementsByTagName('title')[0];
      return title.text = '404 not found';
    },
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].from(el, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut,
        onComplete: done
      });
    },
    leave: function leave(el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done();
      } else {
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(el, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut,
          onComplete: done
        });
      }
    }
  }

});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'EmptySlide',

  methods: {
    enter: function enter(el, done) {
      setTimeout(done, 500);
    }
  }

});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_the_footer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_the_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__layout_the_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scroll_marker__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scroll_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_scroll_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dots__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dots___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_dots__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scroller__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__intro_slide__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__intro_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__intro_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__regular_slide__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__regular_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__regular_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__empty_slide__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__empty_slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__empty_slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scrollmagic__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scrollmagic__);




var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Homepage',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper___default.a,
    TheFooter: __WEBPACK_IMPORTED_MODULE_8__layout_the_footer___default.a,
    ScrollMarker: __WEBPACK_IMPORTED_MODULE_9__components_scroll_marker___default.a,
    Dots: __WEBPACK_IMPORTED_MODULE_10__components_dots___default.a,
    Scroller: __WEBPACK_IMPORTED_MODULE_11__components_scroller___default.a,
    IntroSlide: __WEBPACK_IMPORTED_MODULE_12__intro_slide___default.a,
    RegularSlide: __WEBPACK_IMPORTED_MODULE_13__regular_slide___default.a,
    EmptySlide: __WEBPACK_IMPORTED_MODULE_14__empty_slide___default.a
  },

  data: function data() {
    return {
      isAnimating: false,
      currentSlide: 0,
      scrolled: null,
      viewport: {
        scroll: null
      }
    };
  },


  computed: {
    pageContent: function pageContent() {
      return this.$store.state.pages.landings.main;
    },
    slides: function slides() {
      var widget = __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(this.pageContent.widgets, { type: 'Presentation' });

      widget.items = widget.map(function (item, index) {
        item.media.json = item.json.url;
        item.media.loop = [8500, 9000, 10000][index]; // slides loop timing
        return item;
      });

      return widget.items;
    },
    currentSlideData: function currentSlideData() {
      return this.slides[this.currentSlide - 1];
    },
    slidesAmount: function slidesAmount() {
      return this.slides.length;
    },
    navigationItems: function navigationItems() {
      return [{ label: 'Intro' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.slides.map(function (item) {
        return { label: item.label };
      })));
    },
    isIntro: function isIntro() {
      return this.currentSlide === 0;
    },
    isLast: function isLast() {
      return this.currentSlide === this.slidesAmount + 1;
    }
  },

  watch: {
    'currentSlide': 'commitCurrentSlide'
  },

  beforeRouteEnter: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var page, errors;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('startLoading');
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('pages/fetchLanding', 'main');

            case 3:
              page = _context.sent;
              errors = [];


              if (!page.title) errors.push('Home page must have a title.');
              if (!page.description) errors.push('Home page must have a description.');
              if (!__WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(page.widgets, { type: 'Presentation' })) errors.push('Home page must have a presentation widget.');

              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('endLoading');

              if (!(errors.length > 0)) {
                _context.next = 12;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context.abrupt('return');

            case 12:

              next();

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),

  beforeRouteUpdate: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
      var page, errors;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(from.params.lang === to.params.lang)) {
                _context2.next = 3;
                break;
              }

              next();
              return _context2.abrupt('return');

            case 3:

              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('startLoading');
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('pages/fetchLanding', 'main');

            case 6:
              page = _context2.sent;
              errors = [];


              if (!page.title) errors.push('Home page must have a title.');
              if (!page.description) errors.push('Home page must have a description.');
              if (!__WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(page.widgets, { 'type': 'Presentation' })) errors.push('Home page must have a presentation widget.');

              __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('endLoading');

              if (!(errors.length > 0)) {
                _context2.next = 15;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context2.abrupt('return');

            case 15:

              next();

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function beforeRouteUpdate(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),

  mounted: function mounted() {
    this.commitCurrentSlide();
    this.setTitle();
    this.$root.$on('keypress', this.onKeypress);

    //scrollMagic
    var vueComponent = this,
        duration = 4;

    window.addEventListener("resize", function () {
      scrollMagicScene.duration(window.innerHeight * duration);
    });

    window.scrollMagicController = new __WEBPACK_IMPORTED_MODULE_15_scrollmagic___default.a.Controller();
    window.scrollMagicScene = new __WEBPACK_IMPORTED_MODULE_15_scrollmagic___default.a.Scene({
      triggerElement: '.magicTrigger1',
      triggerHook: 0.5,
      duration: window.innerHeight * duration
    }).addTo(window.scrollMagicController);

    window.scrollMagicScene.on('progress', function (event) {

      if (event.progress >= 0 && event.progress <= 0.2) {
        vueComponent.currentSlide = 0;
      }
      if (event.progress >= 0.2 && event.progress <= 0.4) {
        vueComponent.currentSlide = 1;
      }
      if (event.progress >= 0.4 && event.progress <= 0.6) {
        vueComponent.currentSlide = 2;
      }
      if (event.progress >= 0.6 && event.progress <= 0.8) {
        vueComponent.currentSlide = 3;
      }
      if (event.progress >= 0.8 && event.progress <= 1) {
        vueComponent.currentSlide = 4;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off();
  },


  methods: {
    setTitle: function setTitle() {
      var title = document.getElementsByTagName('title')[0];
      return title.text = this.pageContent.meta.title;
    },
    commitCurrentSlide: function commitCurrentSlide() {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].commit('setMainPageIntroSlide', {
        current: this.currentSlide,
        total: this.slides.length
      });
    },
    prevSlide: function prevSlide() {
      if (this.isAnimating) return;

      this.currentSlide = Math.max(this.currentSlide - 1, 0);
    },
    nextSlide: function nextSlide() {
      if (this.isAnimating) return;

      this.currentSlide = Math.min(this.currentSlide + 1, this.slidesAmount + 1);
    },
    onKeypress: function onKeypress(event) {
      if (event.keyCode === 38) this.prevSlide();
      if (event.keyCode === 40) this.nextSlide();
    },
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_6_gsap__["TweenMax"].from(el, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Power1"].easeOut,
        onComplete: done
      });
    },
    leave: function leave(el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done();
      } else {
        __WEBPACK_IMPORTED_MODULE_6_gsap__["TweenMax"].to(el, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_6_gsap__["Power1"].easeOut,
          onComplete: done
        });
      }
    }
  }

});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lottie_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'IntroSlide',

  props: {
    label: {
      type: String,
      required: true
    },
    head: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      animation: null
    };
  },


  computed: {
    windowWidth: function windowWidth() {
      return this.$store.getters['window'].width;
    },
    isMobile: function isMobile() {
      return this.windowWidth < 768;
    }
  },

  watch: {
    'windowWidth': 'checkState'
  },

  mounted: function mounted() {
    this.checkState();
  },


  methods: {
    checkState: function checkState() {
      if (this.isMobile && this.animation) {
        this.animation.destroy();
        this.animation = null;
      }

      if (!this.isMobile && this.animation === null) {
        this.initAnimation();
      }
    },
    initAnimation: function initAnimation() {
      if (this.$refs.canvas) {
        this.animation = __WEBPACK_IMPORTED_MODULE_0_lottie_web___default.a.loadAnimation({
          container: this.$refs.canvas,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          //prop for prod build
          path: '/bundle/animations/intro-slide-0.json'
          //prop for dev develpoment
          //          animationData: require('./../../../static/animations/intro-slide-0.json')
        });
      }
    },
    appear: function appear(el, done) {
      var els = el.querySelectorAll('[data-item]');

      __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].staggerFrom(els, 1, {
        autoAlpha: 0,
        scale: 1.2,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeInOut,
        onStart: function onStart() {
          if (this.target) this.target.style.transformOrigin = 'left';
        },
        onComplete: function onComplete() {
          if (this.target) this.target.removeAttribute('style');
        }
      }, 0.1, done);
    },
    enter: function enter(el, done) {
      var els = el.querySelectorAll('[data-item]');

      if (this.$refs.media) {
        __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].from(this.$refs.media, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
        });
      }

      __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].staggerFrom(els, 0.5, {
        autoAlpha: 0,
        y: -this.$store.state.app.window.height / 3,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          if (this.target) this.target.removeAttribute('style');
        }
      }, 0, done);
    },
    leave: function leave(el, done) {
      var els = el.querySelectorAll('[data-item]');

      if (this.$refs.media) {
        __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(this.$refs.media, 1, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
        });
      }

      __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].staggerTo(els, 1, {
        autoAlpha: 0,
        y: -this.$store.state.app.window.height / 3,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
      }, 0, done);
    }
  }

});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lottie_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lottie_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmagic__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scrollmagic__);
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'RegularSlide',

  props: {
    slides: {
      type: Array,
      default: null
    },
    media: {
      type: String,
      required: true
    },
    mediaLoop: {
      type: Number,
      default: null
    },
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      animation: null,
      itemsScrollOffset: []
    };
  },


  computed: {
    windowWidth: function windowWidth() {
      return this.$store.getters['window'].width;
    },
    scrollPage: function scrollPage() {
      return this.$store.getters['window'].scroll;
    },
    isMobile: function isMobile() {
      return this.windowWidth < 768;
    },
    isTable: function isTable() {
      return this.windowWidth <= 1024;
    }
  },

  watch: {
    'windowWidth': 'checkState',
    'scrollPage': 'checkState'
  },

  mounted: function mounted() {
    this.checkState();
    this.checkScrollOffset();
  },


  methods: {
    animatedTrigger: function animatedTrigger() {
      for (var i = 0; i < this.itemsScrollOffset.length; i++) {
        var index = this.itemsScrollOffset[i].index;

        if (this.scrollPage > this.itemsScrollOffset[index].offset && !this.itemsScrollOffset[index].animation) {
          this.initAnimation(index);
          this.itemsScrollOffset[index].animation = true;
          return;
        }
      }
    },
    checkScrollOffset: function checkScrollOffset() {
      for (var i = 0; i < this.$refs.item.length; i++) {
        this.itemsScrollOffset.push({
          offset: this.$refs.item[i].offsetTop,
          index: i,
          animation: false
        });
      }
    },
    checkState: function checkState() {
      if (this.isMobile && this.animation) {
        this.animation.removeEventListener('complete');
        this.animation.destroy();
        this.animation = null;
      }

      if (!this.isMobile && this.animation === null) {
        this.initAnimation();
      }
    },
    initAnimation: function initAnimation() {
      var _this = this;

      if (this.$refs.canvas) {
        this.animation = __WEBPACK_IMPORTED_MODULE_0_lottie_web___default.a.loadAnimation({
          container: this.$refs.canvas,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: this.media
        });

        if (this.mediaLoop) {
          this.animation.addEventListener('complete', function () {
            _this.animation.goToAndPlay(_this.mediaLoop, false);
          });
        }
      }
    },
    destroyAnimation: function destroyAnimation(index) {},
    enter: function enter(el, done) {
      var line = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({
        onComplete: done
      });

      line.from(this.$refs.media, 0.5, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          if (this.target) this.target.removeAttribute('style');
        }
      });

      line.from(this.$refs.title, 0.5, {
        autoAlpha: 0,
        y: 40,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          if (this.target) this.target.removeAttribute('style');
        }
      }, '-=0.1');

      line.from(this.$refs.text, 0.5, {
        autoAlpha: 0,
        x: 40,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          if (this.target) this.target.removeAttribute('style');
        }
      }, '-=0.25');
    },
    leave: function leave(el, done) {
      var line = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({
        onComplete: done
      });

      line.to(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
      });

      var content = [this.$refs.title, this.$refs.text];

      line.to(content, 0.5, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power1"].easeOut
      }, 0.1);
    }
  }

});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_base_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__load_more_button__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__load_more_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__load_more_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_wrappers_transition_wrapper__);
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'List',

  components: {
    BaseButton: __WEBPACK_IMPORTED_MODULE_1__components_base_button___default.a,
    LoadMoreButton: __WEBPACK_IMPORTED_MODULE_2__load_more_button___default.a,
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_3__layout_wrappers_transition_wrapper___default.a
  },

  props: {
    type: {
      type: String,
      required: true,
      validator: function validator(value) {
        var isValid = value.match(/^(?:news|projects)$/);
        if (!isValid) console.warn('Validator message: List type must be "projects" or "news".');
        return isValid;
      }
    },
    items: {
      type: Array,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },

  filters: {
    formatDate: function formatDate(timestamp) {
      var date = new Date(timestamp);
      var day = date.getDate().toString().length < 2 ? '0' + date.getDate() : date.getDate();
      var month = date.getMonth().toString().length < 2 ? '0' + date.getMonth() : date.getMonth();
      var year = date.getFullYear();

      return day + ' / ' + month + ' / ' + year;
    }
  },

  data: function data() {
    return {
      visible: false,
      height: 0
    };
  },


  computed: {
    hasHiddenItems: function hasHiddenItems() {
      return this.count > this.items.length;
    },
    lang: function lang() {
      return this.$route.params.lang ? this.$route.params.lang : 'ua';
    }
  },

  watch: {
    '$store.state.app.window.width': 'calculateHeight',
    height: function height(value) {
      var duration = Math.max(0.5 * (this.items.length / 2), 0.5);

      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(this.$refs.bg, duration, {
        height: value,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeInOut,
        force3D: true
      });
    }
  },

  methods: {
    calculateHeight: function calculateHeight() {
      this.height = this.$el.getBoundingClientRect().height;
    },
    getBackgroundImage: function getBackgroundImage(item) {
      if (item.media && item.media.image) {
        return 'background-image: url(' + item.media.image.url + ')';
      } else {
        return 'background-image: url(/public/images/project-cover.jpg)';
      }
    },
    appear: function appear(el, done) {
      if (this.$refs.noNewsMessage) {
        this.calculateHeight();

        __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(this.$refs.noNewsMessage, 1, {
          y: -20,
          autoAlpha: 0,
          delay: 0.5,
          ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
        });

        return;
      }
    },
    itemEnter: function itemEnter(el, done) {
      var stagger = el.dataset.index * 0.1;
      var delay = this.visible ? 0 : 0.5;

      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(el, 0.5, {
        autoAlpha: 0,
        y: -40,
        delay: stagger + delay,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: done
      });

      this.calculateHeight();
    }
  }

});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'LoadMoreButton',

  computed: {
    isLoading: function isLoading() {
      return this.$store.getters['pages/loading'];
    }
  },

  methods: {
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].from(el, 1, {
        autoAlpha: 0,
        delay: 1,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: done
      });
    },
    leave: function leave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(el, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut,
        onComplete: done
      });
    }
  }

});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scroll_marker__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scroll_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_scroll_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__list__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_the_footer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_the_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__layout_the_footer__);



var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'NewsPage',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default.a,
    ScrollMarker: __WEBPACK_IMPORTED_MODULE_5__components_scroll_marker___default.a,
    List: __WEBPACK_IMPORTED_MODULE_6__list___default.a,
    TheFooter: __WEBPACK_IMPORTED_MODULE_7__layout_the_footer___default.a
  },

  computed: {
    $content: function $content() {
      return this.$store.state.pages.landings.news;
    },
    items: function items() {
      return this.$store.getters['pages/all']('news');
    },
    count: function count() {
      return parseInt(this.$content.count);
    }
  },

  beforeRouteEnter: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var page, items, errors;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('startLoading');

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchLanding', 'news');

            case 3:
              page = _context.sent;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchDynamic', {
                name: 'news',
                limit: 7,
                offset: 0,
                firstLoad: true
              });

            case 6:
              items = _context.sent;


              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('endLoading');

              errors = [];


              if (!page.title) errors.push('News page must have a title.');
              if (!page.description) errors.push('News page must have a description.');
              if (items.length <= 0) errors.push('News page must have at least one story.');

              if (!(errors.length > 0)) {
                _context.next = 15;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context.abrupt('return');

            case 15:

              next();

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),

  beforeRouteUpdate: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
      var page, items, errors;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(from.params.lang === to.params.lang)) {
                _context2.next = 3;
                break;
              }

              next();
              return _context2.abrupt('return');

            case 3:

              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('startLoading');

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchLanding', 'news');

            case 6:
              page = _context2.sent;
              _context2.next = 9;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchDynamic', {
                name: 'news',
                limit: 7,
                offset: 0,
                firstLoad: true
              });

            case 9:
              items = _context2.sent;


              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('endLoading');

              errors = [];


              if (!page.title) errors.push('News page must have a title.');
              if (!page.description) errors.push('News page must have a description.');
              if (items.length <= 0) errors.push('News page must have at least one story.');

              if (!(errors.length > 0)) {
                _context2.next = 18;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context2.abrupt('return');

            case 18:

              next();

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function beforeRouteUpdate(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),

  created: function created() {
    this.setTitle();
  },


  methods: {
    setTitle: function setTitle() {
      var title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },
    loadMore: function loadMore() {
      var lastItem = this.items[this.items.length - 1];
      var timestamp = new Date(lastItem.createdAt).getTime();

      this.$store.dispatch('pages/fetchDynamic', {
        name: 'news',
        limit: 7,
        offset: this.items.length
      });
    },
    enter: function enter() {
      var tl = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]();
      var els = [this.$refs.title, this.$refs.subtitle];

      tl.staggerFrom(els, 1, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut
      }, 0.1);
    },
    leave: function leave(el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done();
      } else {
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(el, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut,
          onComplete: done
        });
      }
    },
    scroll: function scroll() {
      var bb = this.$refs.list.$el.getBoundingClientRect();
      var scroll = this.$store.state.app.window.scroll + bb.top;

      __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(window, 1, {
        scrollTo: scroll,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeInOut
      });
    }
  }

});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scroll_marker__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_scroll_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_scroll_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_base_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__list__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_the_footer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_the_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__layout_the_footer__);



var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ProjectsPage',

  components: {
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_4__layout_wrappers_transition_wrapper___default.a,
    ScrollMarker: __WEBPACK_IMPORTED_MODULE_5__components_scroll_marker___default.a,
    List: __WEBPACK_IMPORTED_MODULE_7__list___default.a,
    BaseButton: __WEBPACK_IMPORTED_MODULE_6__components_base_button___default.a,
    TheFooter: __WEBPACK_IMPORTED_MODULE_8__layout_the_footer___default.a
  },

  computed: {
    $content: function $content() {
      return this.$store.state.pages.landings.projects;
    },
    all: function all() {
      return this.$store.getters['pages/all']('projects');
    },
    primary: function primary() {
      return this.$store.getters['pages/primary']('projects');
    },
    items: function items() {
      return this.$store.getters['pages/items']('projects');
    },
    count: function count() {
      return parseInt(this.$content.count);
    },
    lang: function lang() {
      return this.$route.params.lang ? this.$route.params.lang : 'ua';
    }
  },

  beforeRouteEnter: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var page, items, errors;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('startLoading');

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchLanding', 'projects');

            case 3:
              page = _context.sent;
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchDynamic', {
                name: 'projects',
                limit: 7,
                offset: 0,
                firstLoad: true
              });

            case 6:
              items = _context.sent;


              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('endLoading');

              errors = [];


              if (items.length <= 0) errors.push('Projects page must have at least one project.');

              if (!(errors.length > 0)) {
                _context.next = 13;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context.abrupt('return');

            case 13:

              next();

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),

  beforeRouteUpdate: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
      var page, items, errors;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(from.params.lang === to.params.lang)) {
                _context2.next = 3;
                break;
              }

              next();
              return _context2.abrupt('return');

            case 3:

              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('startLoading');

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchLanding', 'projects');

            case 6:
              page = _context2.sent;
              _context2.next = 9;
              return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('pages/fetchDynamic', {
                name: 'projects',
                limit: 7,
                offset: 0,
                firstLoad: true
              });

            case 9:
              items = _context2.sent;


              __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit('endLoading');

              errors = [];


              console.log(errors);

              if (items.length <= 0) errors.push('Projects page must have at least one project.');

              if (!(errors.length > 0)) {
                _context2.next = 17;
                break;
              }

              next({
                path: '/' + (from.params.lang || 'ua') + '/error',
                query: { code: 500, errors: errors }
              });
              return _context2.abrupt('return');

            case 17:

              next();

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function beforeRouteUpdate(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),

  created: function created() {
    this.setTitle();
  },


  methods: {
    setTitle: function setTitle() {
      var title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },
    loadMore: function loadMore() {
      var lastItem = this.items[this.items.length - 1];

      this.$store.dispatch('pages/fetchDynamic', {
        name: 'projects',
        limit: 7,
        offset: this.items.length + 1
      });
    },
    getBackgroundImage: function getBackgroundImage(item) {
      if (item.media && item.media.image) {
        return 'background-image: url(' + item.media.image.url + ')';
      } else {
        return 'background-image: url(/public/images/project-cover.jpg)';
      }
    },
    enter: function enter() {
      var tl = new __WEBPACK_IMPORTED_MODULE_3_gsap__["TimelineMax"]();
      var els = [this.$refs.cat, this.$refs.title, this.$refs.button.$el];

      tl.staggerFrom(els, 1, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut
      }, 0.1);

      tl.from(this.$refs.thumb, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut
        // onUpdate: () => {
        //   if (!this.$refs.thumb) return

        //   const x = this.$refs.thumb.style.opacity * 100

        //   Tween.set(this.$refs.thumb, {
        //     clipPath: `polygon(0% 0%, ${x}% 0%, ${x}% 100%, 0% 100%)`
        //   })
        // }
      }, 0.2);
    },
    leave: function leave(el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done();
      } else {
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(el, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeOut,
          onComplete: done
        });
      }
    },
    scroll: function scroll() {
      var bb = this.$refs.list.$el.getBoundingClientRect();
      var scroll = this.$store.state.app.window.scroll + bb.top;

      __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenMax"].to(window, 1, {
        scrollTo: scroll,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap__["Power1"].easeInOut
      });
    }
  }

});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_groupBy__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_wrappers_appearance_wrapper__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_wrappers_appearance_wrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__layout_wrappers_appearance_wrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scroll_marker__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_scroll_marker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_scroll_marker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__widgets__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_the_footer__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_the_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__layout_the_footer__);




var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PostPage',

  components: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    TransitionWrapper: __WEBPACK_IMPORTED_MODULE_7__layout_wrappers_transition_wrapper___default.a,
    AppearanceWrapper: __WEBPACK_IMPORTED_MODULE_8__layout_wrappers_appearance_wrapper___default.a,
    ScrollMarker: __WEBPACK_IMPORTED_MODULE_9__components_scroll_marker___default.a
  }, __WEBPACK_IMPORTED_MODULE_10__widgets__, {
    TheFooter: __WEBPACK_IMPORTED_MODULE_11__layout_the_footer___default.a
  }),

  filters: {
    formatDate: function formatDate(timestamp) {
      var date = new Date(timestamp);
      var day = date.getDate().toString().length < 2 ? '0' + date.getDate() : date.getDate();
      var month = date.getMonth().toString().length < 2 ? '0' + date.getMonth() : date.getMonth();
      var year = date.getFullYear();

      return day + ' / ' + month + ' / ' + year;
    }
  },

  data: function data() {
    return {
      scrollVisible: false
    };
  },


  computed: {
    slug: function slug() {
      return this.$route.params.slug;
    },
    type: function type() {
      if (this.$route.name.match(/story/)) return 'story';
      if (this.$route.name.match(/project/)) return 'project';

      this.$route.redirect('404');
    },
    $content: function $content() {
      return this.$store.state.pages.inners[this.slug];
    },
    $widgets: function $widgets() {
      var array = [];

      return __WEBPACK_IMPORTED_MODULE_6_lodash_groupBy___default()(this.$content.widgets, 'type');
    }
  },

  beforeRouteEnter: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
      var errors, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('startLoading');
              console.log('beforeRouteEnter');

              errors = [];
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('pages/fetchInner', { url: to.path.split('/')[2], name: to.params.slug });

            case 5:
              data = _context.sent;


              if (data.status === 404) errors.push(404);
              if (!data.title) errors.push('post must have a title');
              if (!data.pageMedia || !data.pageMedia.image) errors.push('post must have an image');
              if (to.name === 'project' && !__WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(data.widgets, { type: 'EntityDescription' })) errors.push('project must have an \'EntityDescription\' widget');

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('endLoading');

              if (!(errors.length > 0)) {
                _context.next = 15;
                break;
              }

              console.log(to, from);

              if (errors[0] === 404) {
                console.log(_this);
                next({
                  path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
                  query: {
                    code: 404
                  }
                });
              } else {
                next({
                  path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
                  query: {
                    code: 500,
                    errors: errors
                  }
                });
              }

              return _context.abrupt('return');

            case 15:

              next();

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),

  beforeRouteUpdate: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
      var errors, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(from.params.lang === to.params.lang)) {
                _context2.next = 3;
                break;
              }

              next();
              return _context2.abrupt('return');

            case 3:

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('startLoading');

              errors = [];
              _context2.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('pages/fetchInner', { url: to.path.split('/')[2], name: to.params.slug });

            case 7:
              data = _context2.sent;


              if (data.status === 404) errors.push(404);
              if (!data.title) errors.push('post must have a title');
              if (!data.pageMedia || !data.pageMedia.image) errors.push('post must have an image');
              if (to.name === 'project' && !__WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(data.widgets, { type: 'EntityDescription' })) errors.push('project must have an \'EntityDescription\' widget');

              __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('endLoading');

              if (errors.length > 0) {
                console.log(to, from);

                if (errors[0] === 404) {

                  next({
                    path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
                    query: {
                      code: 404
                    }
                  });
                } else {

                  next({
                    path: '/' + (from.params.lang || to.params.lang || 'ua') + '/error',
                    query: {
                      code: 500,
                      errors: errors
                    }
                  });
                }
              }

              next();

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function beforeRouteUpdate(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),

  created: function created() {
    this.setTitle();
  },


  methods: {
    setTitle: function setTitle() {
      var title = document.getElementsByTagName('title')[0];
      return title.text = this.$content.meta.title;
    },
    enter: function enter(el, done) {
      var tl = new __WEBPACK_IMPORTED_MODULE_4_gsap__["TimelineMax"]({ onComplete: function onComplete() {
          return done;
        } });
      var group = el.querySelectorAll('[data-item]');

      tl.from(group, 1, {
        autoAlpha: 0,
        y: -40,
        ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut
      });

      tl.set(this, {
        scrollVisible: true
      }, 0.6);

      tl.from(this.$refs.image, 0.5, {
        y: -20,
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut,
        // onUpdate: () => {
        //   if (!this.$refs.image) return

        //   const y = this.$refs.image.style.opacity * 100

        //   Tween.set(this.$refs.image, {
        //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
        //   })
        // },
        onComplete: function onComplete() {
          if (this.target) this.target.removeAttribute('style');
        }
      }, '+=0.6');

      // tl.from(this.$refs.image, 1, {
      //   autoAlpha: 0,
      //   ease: Power1.easeIn
      // }, '+=0.6')
    },
    leave: function leave(el, done) {
      if (this.$store.state.app.routeChangedFromPopup) {
        done();
      } else {
        __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(el, 0.5, {
          autoAlpha: 0,
          ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut,
          onComplete: done
        });
      }
    },
    scroll: function scroll() {
      // const bb = this.$refs.description.$el.getBoundingClientRect()

      // const offset = bb.top - ((this.$store.state.app.window.height - bb.height) / 2)
      // const scroll = this.$store.state.app.window.scroll + offset
      var scroll = this.$store.state.app.window.height;

      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(window, 1, {
        scrollTo: scroll,
        ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeInOut
      });
    },
    getWidgetType: function getWidgetType(type) {
      switch (type) {
        case 'EntityDescription':
          return 'ProjectDescription';
        case 'Text':
          return 'TextCommon';
        case 'Accent':
          return 'TextAccent';
        case 'Aside':
          return 'TextAside';
        default:
          return type;
      }
    },
    validateWidget: function validateWidget(widget) {

      var errors = [];
      if (widget.type === 'Accent') errors = this.checkWidgetFields(widget, 'title', 'content');
      if (widget.type === 'Aside') errors = this.checkWidgetFields(widget, 'title', 'description', 'media');
      if (widget.type === 'Media') errors = this.checkWidgetFields(widget, 'title', 'description', 'media');
      if (widget.type === 'Player') errors = this.checkWidgetFields(widget, 'poster', 'media');
      if (widget.type === 'EntityDescription') errors = this.checkWidgetFields(widget, 'entityType', 'year', 'client');
      if (widget.type === 'Slider') errors = this.checkWidgetFields(widget, 'items');
      if (widget.type === 'Text') errors = this.checkWidgetFields(widget, 'content');

      if (errors.length <= 0) return true;

      errors.forEach(function (error) {
        return console.warn(error);
      });
    },
    checkWidgetFields: function checkWidgetFields(widget) {
      var errors = [];

      if (widget.type === 'EntityDescription') {
        if (!widget.entityType) errors.push(widget.type + ' widget must have a field: "entityType"');
        if (!widget.year) errors.push(widget.type + ' widget must have a field: "year"');
        if (!widget.client) errors.push(widget.type + ' widget must have a field: "client"');
      }

      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return fields.reduce(function (errors, field) {
        if (!widget.hasOwnProperty(field) || widget[field].length <= 0) errors.push(widget.type + ' widget must have a field: "' + field + '"');
        return errors;
      }, errors);
    }
  }

});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TextAccentWidget',

  props: {
    content: [Object]
  },

  data: function data() {
    return {
      tl: null
    };
  },


  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
      var group = [];

      if (this.$refs.title) group.push(this.$refs.title);
      if (this.$refs.content) group.push(this.$refs.content);

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.1);
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'AsideWidget',

  props: {
    content: [Object]
  },

  data: function data() {
    return {
      tl: null
    };
  },


  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
      var group = [];

      if (this.$refs.title) group.push(this.$refs.title);
      if (this.$refs.content) group.push(this.$refs.content);

      var rtl = this.content.alignment === 'right';
      var contentStart = rtl ? 0.3 : 0;
      var mediaStart = rtl ? 0 : 0.3;

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.1, contentStart);

      tl.from(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
        // onUpdate: () => {
        //   const x = this.$refs.media.style.opacity * 100

        //   Tween.set(this.$refs.media, {
        //     clipPath: `polygon(0% 0%, ${x}% 0%, ${x}% 100%, 0% 100%)`
        //   })
        // }
      }, mediaStart);
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'MediaWidget',

  props: {
    content: [Object]
  },

  data: function data() {
    return {
      tl: null
    };
  },


  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
      var group = [];

      if (this.$refs.title) group.push(this.$refs.title);
      if (this.$refs.content) group.push(this.$refs.content);

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.1);

      tl.from(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
        // onUpdate: () => {
        //   const y = this.$refs.media.style.opacity * 100

        //   Tween.set(this.$refs.media, {
        //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
        //   })
        // }
      }, 0.3);

      if (this.$refs.note) {
        tl.from(this.$refs.note, 1, {
          autoAlpha: 0,
          y: -20,
          ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
        }, 1.2);
      }
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PlayerWidget',

  props: {
    content: [Object]
  },

  data: function data() {
    return {
      poster: true,
      playing: false,
      tl: null
    };
  },


  methods: {
    play: function play() {
      this.$refs.video.play();
    },
    stop: function stop() {
      this.$refs.video.pause();
    },
    onStatusChange: function onStatusChange() {
      this.playing = !this.$refs.video.paused;
      if (this.poster) this.poster = false;
    },
    onPlay: function onPlay(event) {
      this.progress = event.target.currentTime;
    },
    onEnd: function onEnd() {
      this.$refs.video.currentTime = 0;
    },
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });

      tl.from(this.$refs.media, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
        // onUpdate: () => {
        //   const y = this.$refs.media.style.opacity * 100

        //   Tween.set(this.$refs.media, {
        //     clipPath: `polygon(0% 0%, 100% 0%, 100% ${y}%, 0% ${y}%)`
        //   })
        // }
      });

      if (this.$refs.note) {
        tl.from(this.$refs.note, 1, {
          autoAlpha: 0,
          y: -20,
          ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
        }, 0.9);
      }
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_button__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_base_button__);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ProjectDescriptionWidget',

  components: {
    BaseButton: __WEBPACK_IMPORTED_MODULE_1__components_base_button___default.a
  },

  props: {
    content: [Object]
  },

  data: function data() {
    return {
      tl: null
    };
  },


  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
      var group = [];

      if (this.$refs.type) group.push(this.$refs.type);
      if (this.$refs.year) group.push(this.$refs.year);
      if (this.$refs.client) group.push(this.$refs.client);
      if (this.$refs.button) group.push(this.$refs.button.$el);
      if (this.$refs.goal) group.push(this.$refs.goal);

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.1);
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'SliderWidget',

  props: {
    content: [Object]
  },

  data: function data() {
    return {
      tl: null,
      offset: 0,
      scroll: 0,
      maxScroll: 0
    };
  },


  watch: {
    '$store.state.app.window.width': 'getOffset'
  },

  mounted: function mounted() {
    this.getOffset();
  },


  methods: {
    getOffset: function getOffset() {

      var images = this.$refs.img;

      for (var i = 0; i < images.length; i++) {
        images[i].style.height = 'auto';
      }

      this.$nextTick(function () {
        for (var _i = 0; _i < images.length; _i++) {
          images[_i].style.height = '100%';
        }
      });

      this.offset = parseInt(getComputedStyle(this.$refs.slides[0]).marginLeft);
      this.maxScroll = this.$refs.track.offsetWidth - this.$refs.scrollable.offsetWidth;
    },
    getScroll: function getScroll() {
      this.scroll = this.$refs.scrollable.scrollLeft;
    },
    changeSlide: function changeSlide(mod) {
      var _this = this;

      var closestSlide = this.$refs.slides.reduce(function (closest, slide, index) {
        var distance = Math.abs(slide.getBoundingClientRect().left - _this.offset);

        if (distance < closest.distance) {
          closest.slide = slide;
          closest.distance = distance;
          closest.index = index;
        }

        return closest;
      }, { slide: null, distance: 9999999, index: -1 });

      var nextSlideIndex = mod < 0 ? Math.max(closestSlide.index + mod, 0) : Math.min(closestSlide.index + mod, this.$refs.slides.length - 1);

      var scroll = this.$refs.slides[nextSlideIndex].offsetLeft - this.offset;

      __WEBPACK_IMPORTED_MODULE_0_gsap__["TweenMax"].to(this.$refs.scrollable, 0.5, {
        scrollTo: {
          x: nextSlideIndex >= this.$refs.slides.length - 1 ? 'max' : scroll,
          autoKill: false
        },
        overwrite: 'all',
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeInOut
      });

      this.maxScroll = this.$refs.track.offsetWidth - this.$refs.scrollable.offsetWidth;
    },


    // ===========================================
    // Animations
    // ===========================================

    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true, onStart: this.getOffset });
      var group = [];

      if (this.$refs.title) group.push(this.$refs.title);
      if (this.$refs.content) group.push(this.$refs.content);
      group.push(this.$refs.arrows);

      tl.from(this.$refs.bg, 1, {
        scaleY: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      });

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.1, 0.3);

      tl.staggerFrom(this.$refs.slides, 1, {
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.2, 0.3);
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'TextWidget',

  props: {
    content: [Object]
  },

  data: function data() {
    return {
      tl: null
    };
  },


  methods: {
    beforeAppear: function beforeAppear() {
      var tl = this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({ paused: true });
      var group = [];

      if (this.$refs.title) group.push(this.$refs.title);
      if (this.$refs.content) group.push(this.$refs.content);

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power1"].easeOut
      }, 0.1);
    },
    appear: function appear() {
      this.tl.play();
    }
  }

});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  development: {
    api: 'https://api.site.dev.aurocraft.com/v1/',
    host: 'https://aurocraft.com'
  },
  production: {
    // api: 'https://api.site.dev.aurocraft.com/v1/',
    api: 'https://api.aurocraft.com/v1/',
    host: '' + window.location.origin.replace('cms.', '')
  },
  testing: {
    api: 'https://api.site.dev.aurocraft.com/v1/',
    host: 'https://aurocraft.com'
  }
};

/* harmony default export */ __webpack_exports__["a"] = (config["production"]);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_i18n__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_v_md__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_v_touch__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gsap_src_uncompressed_plugins_ScrollToPlugin__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_gsap_src_uncompressed_plugins_ScrollToPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_gsap_src_uncompressed_plugins_ScrollToPlugin__);













__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  el: '#app'
}, __WEBPACK_IMPORTED_MODULE_6__App___default.a, {
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
}));

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_description__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project_description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__project_description__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ProjectDescription", function() { return __WEBPACK_IMPORTED_MODULE_0__project_description___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__text__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TextCommon", function() { return __WEBPACK_IMPORTED_MODULE_1__text___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accent__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__accent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TextAccent", function() { return __WEBPACK_IMPORTED_MODULE_2__accent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aside__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__aside__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TextAside", function() { return __WEBPACK_IMPORTED_MODULE_3__aside___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__media__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return __WEBPACK_IMPORTED_MODULE_4__media___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__player__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__player__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Player", function() { return __WEBPACK_IMPORTED_MODULE_5__player___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slider__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__slider__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return __WEBPACK_IMPORTED_MODULE_6__slider___default.a; });















/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* unused harmony default export */ var _unused_webpack_default_export = (function (axios) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;


  // Response interceptor
  axios.interceptors.response.use(function (response) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      return setTimeout(function () {
        return resolve(response);
      }, time);
    });
  });
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* unused harmony default export */ var _unused_webpack_default_export = (function (axios) {

  // Request interceptor
  axios.interceptors.request.use(function (config) {
    console.log('%c --> ' + config.method.toUpperCase(), 'color: green', config.data);
    return config;
  }, function (error) {
    console.log('%c --X ', 'color: red', error);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });

  // Response interceptor
  axios.interceptors.response.use(function (response) {
    console.log('%c <--', 'color: green', response.data);
    return response;
  }, function (error) {

    console.log('%c X-- ' + error.config.method.toUpperCase() + ' ' + error.response.status, 'color: red', error.response.data);
    return error.response;
    // return Promise.reject(error)
  });
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SERVER = null;

var parser = {

  // ===========================================
  // Tests
  // ===========================================

  isSameHost: function isSameHost(url) {
    if (!url || SERVER) return false;

    var host = window.location.hostname;
    var result = url.match(host);

    return result;
  },
  hasHost: function hasHost(url) {
    if (!url || SERVER) return false;

    var result = url.match(/^\/?[^:]*$/i);

    return !result;
  },
  isFile: function isFile(url) {
    if (!url || SERVER) return false;

    return url.match(/(\/|^)[^.:\\\/]*[.]{1}[^.:\/\\]*$/i);
  },
  isOuter: function isOuter(url) {
    if (!url || SERVER) return false;

    var isOuter = !(this.isSameHost(url) || !this.hasHost(url));

    return isOuter;
  },
  isInner: function isInner(url) {
    return !this.isOuter(url) && !this.isFile(url);
  },
  isMail: function isMail(url) {
    return url.match(/^mailto\:/i);
  },


  // ===========================================
  // Getters
  // ===========================================

  getTarget: function getTarget(url) {
    if (!url) return '_blank';

    return this.isOuter(url) || this.isFile(url) ? '_blank' : '_self';
  },
  getUrl: function getUrl(url) {
    if (!url || SERVER) return url;

    if (this.isMail(url)) return url;
    if (this.isOuter(url)) return url.search(/^http[s]?\:\/\//) === -1 ? 'http://' + url : url;
    if (this.isFile(url)) return this.hasHost ? 'http://' + window.location.host + (url.match(/^\//) ? '' : '/') + url : url;

    return url;
  },
  getStaticUrl: function getStaticUrl(url) {
    if (!url || SERVER) return url;

    if (url.match(/^\/?[a-zA-Z0-9-]*((\/.*$)|($))/gi)) {
      return window.location.protocol + '//' + window.location.host + (url.match(/^\//) ? '' : '/') + url;
    }

    return url.search(/^http[s]?\:\/\//) === -1 ? 'http://' + url : url;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (parser);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);



var _this = this;





/* harmony default export */ __webpack_exports__["a"] = ({

  state: {
    loading: true,
    reseting: true, // first loading after changing lang before new meta is fetched
    routeChangedFromPopup: false, // self-explanatory
    animating: false,
    blocked: false,

    mainPageIntroSlide: false,
    mainPageLastSlide: false,
    mainPageSecondSlide: false,

    window: {
      scroll: 0,
      width: window.innerWidth,
      height: window.innerHeight
    },

    meta: {},
    lang: null
  },

  getters: {
    isLoading: function isLoading(state) {
      return state.loading;
    },
    isReseting: function isReseting(state) {
      return state.reseting;
    },
    isAnimating: function isAnimating(state) {
      return state.animating;
    },
    isBlocked: function isBlocked(state) {
      return state.blocked;
    },
    window: function window(state) {
      return state.window;
    },
    meta: function meta(state) {
      return state.meta;
    },
    pages: function pages(state) {
      return state.meta.pages;
    },
    isMobile: function isMobile(state) {
      return state.window.width < 768;
    }
  },

  mutations: {
    // Common data

    setMeta: function setMeta(state, data) {
      state.meta = data;
    },

    setLanguage: function setLanguage(state, lang) {
      state.lang = lang;
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.set(lang);
    },

    // Window events

    resize: function resize(state, _ref) {
      var width = _ref.width,
          height = _ref.height;

      state.window.width = width;
      state.window.height = height;
    },

    scroll: function scroll(state, _scroll) {
      state.window.scroll = _scroll;
    },

    // Loading

    startLoading: function startLoading(state, reseting) {
      state.loading = true;

      if (reseting) state.reseting = true;
    },

    endLoading: function endLoading(state) {
      state.loading = false;
      state.reseting = false;
    },

    // Animation

    popupAnimationStart: function popupAnimationStart(state) {
      state.animating = true;
    },

    popupAnimationEnd: function popupAnimationEnd(state) {
      state.animating = false;
    },

    // Block

    block: function block(state) {
      state.blocked = true;
    },

    unblock: function unblock(state) {
      state.blocked = false;
    },

    // Other

    setMainPageIntroSlide: function setMainPageIntroSlide(state, _ref2) {
      var current = _ref2.current,
          total = _ref2.total;

      state.mainPageIntroSlide = current === 0;
      state.mainPageSecondSlide = current === 2;
      state.mainPageLastSlide = current === total + 1;
    }
  },

  actions: {
    fetchMeta: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref4) {
        var commit = _ref4.commit,
            state = _ref4.state;
        var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ua';
        var response, data, i, locale;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_api__["b" /* default */].meta.get(lang);

              case 2:
                response = _context.sent;
                data = response.data;
                i = 0;
                locale = data.keys.reduce(function (locale, item) {
                  locale[item.key] = item.value;
                  return locale;
                }, {});


                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].i18n.add(state.lang, locale);
                commit('setMeta', data);

                return _context.abrupt('return', data);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function fetchMeta(_x) {
        return _ref3.apply(this, arguments);
      };
    }(),

    openPopup: function openPopup(_ref5, popup) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      commit('openPopup', popup);
      commit('block');

      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to(window, 0.3, {
        scrollTo: {
          y: 0,
          autoKill: false
        },
        ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power1"].easeOut,
        onComplete: function onComplete() {
          commit('unblock');
          dispatch('blockScreen');
        }
      });
    },

    closePopup: function closePopup(_ref6, routeChanged) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('closePopup', routeChanged);
      commit('unblock');
      dispatch('unblockScreen');
    },

    blockScreen: function blockScreen(_ref7) {
      var state = _ref7.state;

      document.documentElement.style.height = state.window.height + 'px';
      document.body.style.height = state.window.height + 'px';
      document.documentElement.style.overflow = 'hidden';
      document.body.style.height = 'hidden';
    },

    unblockScreen: function unblockScreen() {
      document.documentElement.removeAttribute('style');
      document.body.removeAttribute('style');
    }
  }

});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(38);




/* harmony default export */ __webpack_exports__["a"] = ({

  namespaced: true,

  state: {
    opened: false,
    formData: {}
  },

  mutations: {
    reset: function reset(state) {
      state.formData = {};
    },
    updateField: function updateField(state, _ref) {
      var key = _ref.key,
          value = _ref.value;

      state.formData[key] = value;
    }
  },

  actions: {
    send: function send(_ref2, action) {
      var _this = this;

      var state = _ref2.state;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = state.formData;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__services_api__["b" /* default */].form.send(data);

              case 3:
                response = _context.sent;
                return _context.abrupt('return', response);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }

});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pages", function() { return __WEBPACK_IMPORTED_MODULE_1__pages__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "form", function() { return __WEBPACK_IMPORTED_MODULE_2__form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "menu", function() { return __WEBPACK_IMPORTED_MODULE_3__menu__["a"]; });









/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  namespaced: true,

  state: {
    opened: false
  }

});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_unionBy__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_unionBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_unionBy__);






/* harmony default export */ __webpack_exports__["a"] = ({

  namespaced: true,

  state: {
    landings: {},
    inners: {},
    projects: {
      items: [],
      count: 0
    },
    news: {
      items: [],
      count: 0
    },
    loading: false
  },

  getters: {
    all: function all(state) {
      return function (type) {
        return state[type].items;
      };
    },
    primary: function primary(state) {
      return function (type) {
        return state[type].items.length > 0 ? state[type].items[0] : null;
      };
    },
    items: function items(state) {
      return function (type) {
        return state[type].items.filter(function (item, index) {
          return index > 0;
        });
      };
    },
    count: function count(state) {
      return function (type) {
        return state[type].count;
      };
    },
    loading: function loading(state) {
      return state.loading;
    }
  },

  mutations: {
    setLanding: function setLanding(state, _ref) {
      var name = _ref.name,
          data = _ref.data;

      state.landings[name] = data;
    },
    updateList: function updateList(state, _ref2) {
      var name = _ref2.name,
          items = _ref2.items,
          firstLoad = _ref2.firstLoad;

      var list = state[name];
      var newItems = __WEBPACK_IMPORTED_MODULE_4_lodash_unionBy___default()(list.items, items, 'url');

      if (firstLoad) {
        newItems = items;
      } else {
        newItems = __WEBPACK_IMPORTED_MODULE_4_lodash_unionBy___default()(list.items, items, 'url');
      }

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state[name], 'items', newItems);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state[name], 'count', items.length);
    },
    setInner: function setInner(state, _ref3) {
      var name = _ref3.name,
          data = _ref3.data;

      state.inners[name] = data;
    },
    startLoading: function startLoading(state) {
      state.loading = true;
    },
    endLoading: function endLoading(state) {
      state.loading = false;
    }
  },

  actions: {
    fetchLanding: function fetchLanding(_ref4, name) {
      var _this = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_api__["b" /* default */].pages.get(name);

              case 2:
                response = _context.sent;
                data = response.data;


                commit('setLanding', { name: name, data: data });
                return _context.abrupt('return', data);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchDynamic: function fetchDynamic(_ref5, _ref6) {
      var _this2 = this;

      var state = _ref5.state,
          commit = _ref5.commit;
      var name = _ref6.name,
          _ref6$limit = _ref6.limit,
          limit = _ref6$limit === undefined ? null : _ref6$limit,
          offset = _ref6.offset,
          firstLoad = _ref6.firstLoad;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var itemsResponse, items;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('startLoading');

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__services_api__["b" /* default */].pages.getByType(name, limit, offset);

              case 3:
                itemsResponse = _context2.sent;
                items = itemsResponse.data;


                commit('updateList', { name: name, items: items, firstLoad: firstLoad });
                commit('endLoading');

                return _context2.abrupt('return', items);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchInner: function fetchInner(_ref7, _ref8) {
      var _this3 = this;

      var commit = _ref7.commit;
      var url = _ref8.url,
          name = _ref8.name;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_api__["b" /* default */].pages.getDefault(url, name);

              case 2:
                response = _context3.sent;


                if (response === undefined) {
                  response = { data: { status: 404 } };
                }

                data = response.data;


                commit('setInner', { name: name, data: data });

                return _context3.abrupt('return', data);

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }

});

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjIxcHgiIGhlaWdodD0iMTNweCIgdmlld0JveD0iMCAwIDIxIDEzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkuMyAoNTExNjcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPg0KICAgIDx0aXRsZT5Db21iaW5lZCBTaGFwZTwvdGl0bGU+DQogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+DQogICAgPGRlZnM+PC9kZWZzPg0KICAgIDxnIGlkPSJXaWRnZXRzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCiAgICAgICAgPGcgaWQ9IkFydGNpbGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTI2LjAwMDAwMCwgLTMyNjAuMDAwMDAwKSIgZmlsbD0iIzAwNTJBNiI+DQogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA4OS4wMDAwMDAsIDMyNTkuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPHBhdGggZD0iTTQ2LjMwMTQ2Niw5LjQ5NzI4MjYxIEwzNyw5LjQ5NzI4MjYxIEwzNyw1LjUwMjcxNzM5IEw0Ni4zMDE0NjYsNS41MDI3MTczOSBMNDYuMzAxNDY2LDAuOTcyNzk2MDU2IEw1MC40NTA1MTU1LDMuMzMzNzU0NTggTDUzLjUwODc3OTksNS4wNzM5ODg3NSBMNTcuNzE0NTA5NSw3LjQ2NzExNzEgTDUzLjUwODc3OTksOS44NjA1NTE4MyBMNTAuNDUwNTE1NSwxMS42MDA3ODYgTDQ2LjMwMTQ2NiwxMy45NjE3NDQ1IEw0Ni4zMDE0NjYsOS40OTcyODI2MSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjIxcHgiIGhlaWdodD0iMTNweCIgdmlld0JveD0iMCAwIDIxIDEzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkuMyAoNTExNjcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPg0KICAgIDx0aXRsZT5Hcm91cCA3IENvcHk8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPg0KICAgIDxkZWZzPjwvZGVmcz4NCiAgICA8ZyBpZD0iV2lkZ2V0cyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRjaWxlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTA4OS4wMDAwMDAsIC0zMjYwLjAwMDAwMCkiIGZpbGw9IiMwMDUyQTYiPg0KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwODkuMDAwMDAwLCAzMjU5LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC03LUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjUwMDAwMCwgNy4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTEwLjUwMDAwMCwgLTcuMDAwMDAwKSAiPg0KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iUGFnZS0xLUNvcHktMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUuMDA3OTg4LCA3LjQ2NzI3MCkgc2NhbGUoMSwgLTEpIHJvdGF0ZSgtMjcwLjAwMDAwMCkgdHJhbnNsYXRlKC0xNS4wMDc5ODgsIC03LjQ2NzI3MCkgIiBwb2ludHM9IjE1LjAwODE0MDkgMS43NjA3NDg1NSAxMi42MTQ3MDYyIDUuOTY2NDc4MTcgMTAuODc0NDcyIDkuMDI0NzQyNTYgOC41MTM1MTM1MSAxMy4xNzM3OTIgMjEuNTAyNDYyIDEzLjE3Mzc5MiAxOS4xNDE1MDM0IDkuMDI0NzQyNTYgMTcuNDAxMjY5MyA1Ljk2NjQ3ODE3Ij48L3BvbHlnb24+DQogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtOCIgeD0iMCIgeT0iNS41MDI3MTczOSIgd2lkdGg9IjEwLjc4Mzc4MzgiIGhlaWdodD0iMy45OTQ1NjUyMiI+PC9yZWN0Pg0KICAgICAgICAgICAgICAgIDwvZz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjMzcHgiIGhlaWdodD0iMjNweCIgdmlld0JveD0iMCAwIDMzIDIzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDYuMiAoNDQ0OTYpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPg0KICAgIDx0aXRsZT5QYWdlIDE8L3RpdGxlPg0KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPg0KICAgIDxkZWZzPjwvZGVmcz4NCiAgICA8ZyBpZD0iciIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJDb250YWN0cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTgwNS4wMDAwMDAsIC0zMTAuMDAwMDAwKSIgZmlsbD0iI0VFNkI0QyI+DQogICAgICAgICAgICA8ZyBpZD0iUGFnZS0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MDUuMDAwMDAwLCAzMTAuMDAwMDAwKSI+DQogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMSIgcG9pbnRzPSIyOS4wMDU4NTc3IDQuNzczODAxODkgMjkuMDA1ODU3NyAxOC42ODQwMjgzIDMuODA3ODE5MjMgMTguNjg0MDI4MyAzLjgwNzgxOTIzIDQuNzczODAxODkgMC4wMDAxMjY5MjMwNzcgMC4xMzg2NTA5NDMgMC4wMDAxMjY5MjMwNzcgMjIuNTg5Njg4NyAzMi44MTM1NSAyMi41ODk2ODg3IDMyLjgxMzU1IDAuMTM4NjUwOTQzIj48L3BvbHlnb24+DQogICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuNTA1NTQyMzEsLTguNjc5MjQ1MjllLTA1IEwxMC43ODEzMTE1LDYuNDIyNTU0NzIgTDEzLjYwNzQ2NTQsOS44NjI1NzM1OCBMMTYuNTE5NTAzOCwxMy40MDcxNzc0IEwxOS40MzExMTkyLDkuODYyNTczNTggTDIyLjI1NzI3MzEsNi40MjI1NTQ3MiBMMjcuNTMzNDY1NCwtOC42NzkyNDUyOWUtMDUgTDUuNTA1NTQyMzEsLTguNjc5MjQ1MjllLTA1IFogTTEzLjY5MzM1LDMuOTA1NTczNTggTDE5LjM0NTIzNDYsMy45MDU1NzM1OCBMMTYuNTE5NTAzOCw3LjM0NjAyNjQyIEwxMy42OTMzNSwzLjkwNTU3MzU4IFoiIGlkPSJGaWxsLTIiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg=="

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgNDcwLjUxMyA0NzAuNTEzIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzAuNTEzIDQ3MC41MTM7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGQ9Ik0yNzEuNTIxLDE1NC4xN3YtNDAuNTQxYzAtNi4wODYsMC4yOC0xMC44LDAuODQ5LTE0LjEzYzAuNTY3LTMuMzM1LDEuODU3LTYuNjE1LDMuODU5LTkuODUzICAgYzEuOTk5LTMuMjM2LDUuMjM2LTUuNDcsOS43MDYtNi43MDhjNC40NzYtMS4yNCwxMC40MjQtMS44NTgsMTcuODUtMS44NThoNDAuNTM5VjBoLTY0LjgwOWMtMzcuNSwwLTY0LjQzMyw4Ljg5Ny04MC44MDMsMjYuNjkxICAgYy0xNi4zNjgsMTcuNzk4LTI0LjU1MSw0NC4wMTQtMjQuNTUxLDc4LjY1OHY0OC44MmgtNDguNTQydjgxLjA4Nmg0OC41Mzl2MjM1LjI1Nmg5Ny4zNjJWMjM1LjI1Nmg2NC44MDVsOC41NjYtODEuMDg2SDI3MS41MjF6IiBmaWxsPSIjRkZGRkZGIi8+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(493),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77988e42",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(496),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f16c3a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5918ff9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(501),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-abb9619a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(292)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-568053a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-12f409d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(499),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a273b74c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ca9c835",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(472),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a2d0226",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(474),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3379be55",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(287)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(480),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-423ea62a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(495),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7da3fba2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(484),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5499fcf6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ddf5cb6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(483),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-507e84b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3bb55976",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(497),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-87097352",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(488),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5eba9fd5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(478),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c4e7476",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-674edaef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(464),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06d5d17f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(288)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-464149a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(498),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9a0c2650",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(479),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40f03314",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(476),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-371cfcde",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(494),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bd2718a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a6835ab",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(492),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-71b7c26e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(296)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6129d8aa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(475),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35f34312",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    ref: "bg",
    staticClass: "container__background"
  }, [_c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.hasHiddenItems) ? _c('load-more-button', {
    staticClass: "more-button",
    on: {
      "click": function($event) {
        _vm.$emit('load-more-items')
      }
    }
  }) : _vm._e()], 1)], 1), (_vm.items.length > 0) ? _c('transition-group', {
    ref: "list",
    staticClass: "list",
    class: ("is-" + (this.type)),
    attrs: {
      "appear": "appear",
      "tag": "ul"
    },
    on: {
      "enter": _vm.itemEnter
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (_vm.type === 'news') ? _c('li', {
      key: index,
      staticClass: "story",
      attrs: {
        "data-index": index
      }
    }, [_c('router-link', {
      staticClass: "story-thumb",
      style: (_vm.getBackgroundImage(item)),
      attrs: {
        "to": '/' + _vm.lang + '/news' + item.url
      }
    }), _c('div', {
      staticClass: "story-content"
    }, [_c('div', {
      staticClass: "story-content__info"
    }, [_c('a', {
      staticClass: "story-content__title",
      attrs: {
        "url": '/' + _vm.lang + '/news' + item.url
      }
    }, [_vm._v(_vm._s(item.title || 'Story title'))]), _c('div', {
      staticClass: "story-content__date"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.createdAt)))])]), _c('base-button', {
      staticClass: "story-content__link",
      attrs: {
        "url": '/' + _vm.lang + '/news' + item.url,
        "label": _vm.$t('read-article')
      }
    })], 1)], 1) : _vm._e()
  }), _vm._l((_vm.items), function(item, index) {
    return (_vm.type === 'projects') ? _c('li', {
      key: index,
      staticClass: "project",
      attrs: {
        "data-index": index
      }
    }, [_c('router-link', {
      staticClass: "project-link",
      attrs: {
        "to": '/' + _vm.lang + '/projects' + item.url
      }
    }, [_c('div', {
      staticClass: "project-thumb",
      style: (_vm.getBackgroundImage(item))
    }), _c('div', {
      staticClass: "project-content"
    }, [_c('div', {
      staticClass: "project-content__title"
    }, [_vm._v(_vm._s(item.title || 'Project title'))]), _c('div', {
      staticClass: "project-content__cat"
    }, [_vm._v(_vm._s(item.cat))])])])], 1) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "empty-list"
  }, [_c('div', {
    ref: "noNewsMessage",
    staticClass: "empty-list__title"
  }, [_vm._v(_vm._s(_vm.type === 'news' ? _vm.$t('no-news') : _vm.$t('no-projects')))])])], 1)
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog-page"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-container"
  }, [_c('h1', {
    ref: "title",
    staticClass: "intro__heading h1-like"
  }, [_vm._v(_vm._s(_vm.$content.title))]), _c('p', {
    ref: "subtitle",
    staticClass: "intro__description"
  }, [_vm._v(_vm._s(_vm.$content.description))])]), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('scroll-marker', {
    staticClass: "intro__scroll",
    attrs: {
      "dark-mode": true
    },
    on: {
      "click": _vm.scroll
    }
  })], 1)], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "type": "news",
      "items": _vm.items,
      "count": _vm.count
    },
    on: {
      "load-more-items": _vm.loadMore
    }
  })], 1), _c('the-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrap"
  }, [_c('div', {
    ref: "bg",
    staticClass: "menu-background"
  }), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    ref: "content",
    staticClass: "menu-content"
  }, [_c('div', {
    staticClass: "menu-grid",
    class: _vm.gridSize
  }, [_c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      ref: "links",
      refInFor: true,
      staticClass: "menu-list__item"
    }, [_c('router-link', {
      staticClass: "menu-list__link",
      attrs: {
        "to": '/' + _vm.lang + link.url
      },
      nativeOn: {
        "click": function($event) {
          _vm.onLinkClick($event)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(link.name))])])], 1)
  })), _c('footer', {
    staticClass: "menu-bottom"
  }, [_c('ul', {
    staticClass: "social"
  }, _vm._l((_vm.social), function(item) {
    return (_vm.$t(item.name + '-link').length > 0) ? _c('li', {
      ref: "social",
      refInFor: true,
      staticClass: "social__item"
    }, [_c('a', {
      staticClass: "social__link",
      attrs: {
        "href": _vm.$t(item.name + '-link'),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "social__icon",
      class: ("is-" + (item.name)),
      attrs: {
        "src": item.image,
        "alt": ((item.name) + " logo")
      }
    })])]) : _vm._e()
  }))])])])])])
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    ref: "media",
    staticClass: "widget-main widget-main__video"
  }, [_c('div', {
    staticClass: "widget-main__controls widget-controls"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.content.poster && !_vm.playing) ? _c('div', {
    staticClass: "widget-controls__poster"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.poster.url
    }
  })]) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "button"
    }
  }, [(!_vm.playing) ? _c('div', {
    staticClass: "widget-controls__play-button play-button",
    on: {
      "click": _vm.play
    }
  }) : _vm._e()])], 1), _c('video', {
    ref: "video",
    staticClass: "widget-main__video",
    class: {
      'is-playing': _vm.playing
    },
    attrs: {
      "preload": "auto"
    },
    on: {
      "click": _vm.stop,
      "playing": _vm.onStatusChange,
      "pause": _vm.onStatusChange,
      "timeupdate": _vm.onPlay,
      "ended": _vm.onEnd
    }
  }, _vm._l((_vm.content.media), function(video, index) {
    return _c('source', {
      key: index,
      attrs: {
        "src": video.url,
        "type": 'video/' + video.type
      }
    })
  }))]), (_vm.content.note) ? _c('div', {
    ref: "note",
    staticClass: "widget-note"
  }, [_vm._v(_vm._s(_vm.content.note))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "header"
    }
  }, [_c('header', {
    staticClass: "header",
    class: [
      [_vm.state], {
        'header--fixed': _vm.isHomepage
      }
    ]
  }, [_c('div', {
    staticClass: "header__wrapper"
  }, [_c('div', {
    staticClass: "header__column"
  }, [_c('logo', {
    attrs: {
      "mode": _vm.isLogoInverted ? 'white' : 'black'
    }
  }), _c('transition', {
    attrs: {
      "name": "page-name",
      "mode": "out-in"
    }
  }, [(!_vm.isLoading && !_vm.isHomepage && !_vm.isPopupOpened && _vm.pageName && _vm.isMobile) ? _c('div', {
    key: _vm.$route.path + '_' + _vm.$route.name,
    staticClass: "page-name",
    class: {
      'is-inverted': _vm.isLogoInverted
    }
  }, [_c('div', {
    staticClass: "page-name__sep"
  }), _c('div', {
    staticClass: "page-name__label"
  }, [_vm._v(_vm._s(_vm.pageName))])]) : _vm._e()])], 1), _c('div', {
    staticClass: "header__column",
    class: {
      'is-inverted': _vm.isMenuInverted
    }
  }, [_c('lang-switcher'), _c('burger')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-main"
  }, [_c('div', {
    staticClass: "footer-slider"
  }, [_c('div', {
    staticClass: "footer-slider__main"
  }, [_c('slider', {
    attrs: {
      "slideList": _vm.slides
    }
  })], 1)])]), _c('div', {
    staticClass: "footer-mini"
  }, [_c('div', {
    staticClass: "footer-mini__column"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "copyright__text"
  }, [_vm._v(_vm._s(_vm.$t('copyright')))])])]), _c('div', {
    staticClass: "footer-mini__column"
  }, [_c('a', {
    staticClass: "footer-email",
    attrs: {
      "href": ("mailto:" + (_vm.$t('contact-email'))),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact-email')))]), _c('ul', {
    staticClass: "footer-social"
  }, _vm._l((_vm.social), function(item) {
    return (_vm.$t(item + '-link').length > 0) ? _c('li', {
      staticClass: "footer-social__item"
    }, [_c('a', {
      staticClass: "footer-social__link",
      attrs: {
        "href": _vm.$t(item + '-link'),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('social-' + item)))])]) : _vm._e()
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('transition-wrapper', {
    attrs: {
      "appear": true,
      "mode": "out-in"
    }
  }, [(!_vm.isLoading) ? _c('router-view', {
    key: _vm.$route.path,
    staticClass: "router-view"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.$route.name + '-page'],
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$store.state.app.lang,
    staticClass: "layer-1"
  }), _c('the-popup', {
    staticClass: "layer-2"
  }), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.isLoading) ? _c('the-loader', {
    staticClass: "layer-3"
  }) : _vm._e()], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(!_vm.isLoading) ? _c('the-header', {
    staticClass: "layer-4"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "awards"
  }, [_c('div', {
    staticClass: "awards__container"
  }, [_c('div', {
    ref: "background",
    staticClass: "awards__background"
  }), _c('div', {
    staticClass: "awards__wrapper content"
  }, [_c('div', {
    ref: "title",
    staticClass: "content__header"
  }, [_vm._v(_vm._s(_vm.$content.title))]), _c('div', {
    staticClass: "content__main list"
  }, _vm._l((_vm.$content.items), function(award) {
    return _c('div', {
      ref: "items",
      refInFor: true,
      staticClass: "list__item item"
    }, [_c('div', {
      staticClass: "item-hgroup"
    }, [_c('div', {
      staticClass: "item-hgroup__heading"
    }, [_vm._v(_vm._s(award.title))]), _c('div', {
      staticClass: "item-hgroup__label"
    }, [_vm._v(_vm._s(_vm._f("getYear")(award.date)))])]), _c('div', {
      staticClass: "item-content"
    }, [_c('p', {
      staticClass: "item-content__text"
    }, [_vm._v(_vm._s(award.description))])]), _c('div', {
      staticClass: "item-actions"
    }, [_c('base-button', {
      staticClass: "item-actions__button",
      attrs: {
        "label": _vm.$t('launch-site'),
        "url": award.url,
        "white": true
      }
    })], 1)])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "description__wrapper"
  }, [_c('div', {
    staticClass: "description__column main"
  }, [_c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.mainContent),
      expression: "mainContent"
    }],
    ref: "mainContent",
    staticClass: "main__content"
  })]), _c('div', {
    staticClass: "description__column aside"
  }, [_c('div', {
    ref: "asideBg",
    staticClass: "aside__background"
  }), _c('div', {
    ref: "asideGraphic",
    staticClass: "aside__graphic"
  }), _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.asideContent),
      expression: "asideContent"
    }],
    ref: "asideContent",
    staticClass: "aside__content"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "widget__content"
  }, [(_vm.content.title) ? _c('div', {
    ref: "title",
    staticClass: "widget__title"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.content.content),
      expression: "content.content"
    }],
    ref: "content",
    staticClass: "widget__main markdown-container"
  }), _c('div', {
    staticClass: "widget__main markdown-container"
  })])])
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget",
    class: {
      'is-rtl': _vm.content.alignment === 'right'
    }
  }, [_c('div', {
    staticClass: "widget__content"
  }, [_c('div', {
    staticClass: "widget__main"
  }, [(_vm.content.title) ? _c('div', {
    ref: "title",
    staticClass: "widget__title"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.content.description),
      expression: "content.description"
    }],
    ref: "content",
    staticClass: "widget__description markdown-container"
  })]), _c('div', {
    staticClass: "widget__media"
  }, [_c('img', {
    ref: "media",
    attrs: {
      "src": _vm.content.media.url,
      "alt": "image"
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section')
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('article', {
    ref: "item",
    staticClass: "slide-content"
  }, [_c('aside', {
    ref: "media",
    staticClass: "slide-media"
  }, [(_vm.isTable) ? _c('img', {
    staticClass: "slide-media__image",
    attrs: {
      "src": _vm.image,
      "alt": "image"
    }
  }) : _c('div', {
    ref: "canvas",
    staticClass: "slide-media__canvas"
  })]), _c('main', {
    staticClass: "slide-main"
  }, [_c('h3', {
    ref: "title",
    staticClass: "slide-main__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    ref: "text",
    staticClass: "slide-main__text"
  }, [_vm._v(_vm._s(_vm.text))])])])])
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "widget__content"
  }, [(_vm.content.title) ? _c('div', {
    ref: "title",
    staticClass: "widget__title"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.content.content),
      expression: "content.content"
    }],
    ref: "content",
    staticClass: "widget__main markdown-container",
    class: {
      'is-quote': _vm.content.isQuote
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-page"
  }, [_c('div', {
    staticClass: "about-page__content"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-wrapper"
  }, [_c('div', {
    staticClass: "intro-container"
  }, [_c('div', {
    ref: "background",
    staticClass: "intro-background"
  }), _c('div', {
    staticClass: "intro-video"
  }), _c('div', {
    ref: "content",
    staticClass: "intro-content"
  }, [_c('img', {
    staticClass: "intro-logo",
    attrs: {
      "src": __webpack_require__(428)
    }
  }), (_vm.$content.description) ? _c('div', {
    staticClass: "intro-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$content.description)
    }
  }) : _vm._e()]), _c('transition-wrapper', {
    attrs: {
      "appear": true,
      "appear-delay": "0.5"
    }
  }, [_c('scroll-marker', {
    staticClass: "intro-scroll",
    on: {
      "click": _vm.scroll
    }
  })], 1)], 1)]), (_vm.$content.media && _vm.$content.media.image) ? _c('div', {
    ref: "image",
    staticClass: "intro-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.$content.media.image.url,
      "alt": "image"
    }
  })]) : _vm._e()]), _c('appearance-wrapper', [(_vm.$description) ? _c('description', {
    ref: "description",
    attrs: {
      "$content": _vm.$description
    }
  }) : _vm._e()], 1), _c('appearance-wrapper', [(_vm.$partners) ? _c('partners', {
    attrs: {
      "$content": _vm.$partners
    }
  }) : _vm._e()], 1), _c('appearance-wrapper', [(_vm.$awards) ? _c('awards', {
    attrs: {
      "$content": _vm.$awards
    }
  }) : _vm._e()], 1)], 1), _c('the-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-page"
  }, [_c('div', {
    staticClass: "project"
  }, [_c('router-link', {
    staticClass: "project-container",
    attrs: {
      "to": '/' + _vm.lang + '/projects' + _vm.primary.url
    }
  }, [_c('div', {
    staticClass: "project-content"
  }, [_c('div', {
    staticClass: "project-content__info"
  }, [_c('div', {
    ref: "cat",
    staticClass: "project-content__category"
  }, [_vm._v(_vm._s(_vm.primary.cat))]), _c('div', {
    ref: "title",
    staticClass: "project-content__title"
  }, [_vm._v(_vm._s(_vm.primary.title || 'Project title'))])]), _c('base-button', {
    ref: "button",
    staticClass: "project-content__button",
    attrs: {
      "url": '/' + _vm.lang + '/projects' + _vm.primary.url,
      "label": _vm.$t('open-case')
    }
  })], 1), _c('div', {
    ref: "thumb",
    staticClass: "project-thumb",
    style: (_vm.getBackgroundImage(_vm.primary))
  })]), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('scroll-marker', {
    staticClass: "project-scroll",
    attrs: {
      "dark-mode": true,
      "label": _vm.$t('more-cases')
    },
    on: {
      "click": _vm.scroll
    }
  })], 1)], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('list', {
    ref: "list",
    attrs: {
      "type": "projects",
      "items": _vm.items,
      "count": _vm.count - 1
    },
    on: {
      "load-more-items": _vm.loadMore
    }
  })], 1), _c('the-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "appear": _vm.appear,
      "mode": _vm.mode,
      "name": _vm.name,
      "css": false
    },
    on: {
      "beforeAppear": _vm.beforeAppear,
      "appear": _vm.appear_,
      "beforeEnter": _vm.beforeEnter,
      "enter": _vm.enter,
      "beforeLeave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page"
  }, [_c('div', {
    staticClass: "error-page__content"
  }, [_c('h1', {
    staticClass: "error-page__title"
  }, [_vm._v(_vm._s(_vm.code))]), _c('p', {
    staticClass: "error-page__description"
  }, [_vm._v(_vm._s(_vm.message))]), _c('pre', {
    staticClass: "error-page__errors"
  }, _vm._l((_vm.errors), function(error) {
    return _c('p', [_vm._v(_vm._s(error))])
  })), _c('base-button', {
    staticClass: "error-page__button",
    attrs: {
      "label": _vm.$t('go-to-homepage'),
      "url": "/"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "novalidate": "novalidate"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.nextStep($event)
      }
    }
  }, [_c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.visible && _vm.currentStep !== _vm.steps.length + 1) ? _c('dots', {
    staticClass: "form__navigation",
    attrs: {
      "items": _vm.steps,
      "current": _vm.currentStep - 1
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "form__content"
  }, [_c('transition', {
    attrs: {
      "appear": "appear",
      "mode": "out-in"
    },
    on: {
      "enter": _vm.stepEnter,
      "leave": _vm.stepLeave
    }
  }, [(_vm.currentStep <= _vm.steps.length) ? _vm._l((_vm.steps), function(step, index) {
    return (_vm.visible && index + 1 === _vm.currentStep) ? _c('div', {
      key: index,
      staticClass: "step"
    }, [_c('div', {
      staticClass: "step__heading",
      attrs: {
        "data-primary": "data-primary"
      },
      domProps: {
        "innerHTML": _vm._s(step.question)
      }
    }), _c('input', {
      ref: "input",
      refInFor: true,
      staticClass: "step__input",
      attrs: {
        "data-secondary": "data-secondary",
        "autocomplete": "off",
        "autocorrect": "off",
        "name": step.name,
        "type": step.type,
        "data-id": step.name,
        "disabled": _vm.sending
      },
      on: {
        "blur": _vm.onBlur,
        "input": _vm.update
      }
    }), _c('transition', {
      attrs: {
        "name": "fade"
      }
    })], 1) : _vm._e()
  }) : (_vm.sending) ? [_c('div', {
    key: "loader",
    staticClass: "step"
  }, [_c('div', {
    staticClass: "loader",
    attrs: {
      "data-primary": "data-primary"
    }
  }), _c('div', {
    staticClass: "loader__label",
    attrs: {
      "data-secondary": "data-secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('form-sending')))])])] : [_c('div', {
    key: "thank-you",
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__heading is-large",
    attrs: {
      "data-primary": "data-primary"
    }
  }, [_vm._v(_vm._s(_vm.failed ? _vm.$t('form-fail-title') : _vm.$t('form-thank-title')))]), _c('div', {
    staticClass: "step__subheading",
    attrs: {
      "data-secondary": "data-secondary"
    }
  }, [_vm._v(_vm._s(_vm.failed ? _vm.$t('form-fail-subtitle') : _vm.$t('form-thank-subtitle')))]), _c('base-button', {
    ref: "button",
    staticClass: "step__button",
    attrs: {
      "data-secondary": "data-secondary",
      "url": '/',
      "label": _vm.$t('go-to-homepage')
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.commit('closePopup')
      }
    }
  })], 1)]], 2)], 1), _c('transition', {
    attrs: {
      "appear": "appear",
      "name": "fade"
    }
  }, [(_vm.visible && _vm.currentStep <= _vm.steps.length) ? _c('div', {
    staticClass: "form__controls controls"
  }, [_c('button', {
    staticClass: "controls-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentStep <= 1
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('div', {
    staticClass: "controls-button__content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(133),
      "alt": "arrow prev"
    }
  }), _c('span', {
    staticClass: "controls-button__label"
  }, [_vm._v(_vm._s(_vm.$t('form-prev-step')))])])]), _c('div', {
    staticClass: "controls-sep"
  }), _c('button', {
    staticClass: "controls-button",
    attrs: {
      "type": "button",
      "disabled": _vm.currentStep >= _vm.steps.length + 1 || _vm.invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_c('div', {
    staticClass: "controls-button__content"
  }, [_c('span', {
    staticClass: "controls-button__label"
  }, [_vm._v(_vm._s(_vm.$t('form-next-step')))]), _c('img', {
    attrs: {
      "src": __webpack_require__(132),
      "alt": "arrow next"
    }
  })])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.menuOpenMobile) ? _c('div', {
    staticClass: "logo-container"
  }, [_c('router-link', {
    staticClass: "logo-link",
    class: ['is-' + _vm.mode],
    attrs: {
      "to": '/' + _vm.lang
    },
    nativeOn: {
      "click": function($event) {
        _vm.onLinkClick($event)
      }
    }
  }, [_c('svg', {
    staticClass: "logo",
    attrs: {
      "width": "154px",
      "height": "16px",
      "viewBox": "0 0 154 16",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('polygon', {
    attrs: {
      "id": "path-1",
      "points": "14.9082191 0.1115 0.768527941 0.1115 0.768527941 15.8751125 14.9082191 15.8751125 14.9082191 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-3",
      "points": "16.4484456 15.875 0 15.875 0 0.1115 16.4484456 0.1115 16.4484456 15.875"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-5",
      "points": "14.2674206 0.1115 0.554626471 0.1115 0.554626471 15.8751125 14.2674206 15.8751125 14.2674206 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-7",
      "points": "11.7803206 0.1115 0.323173529 0.1115 0.323173529 15.829325 11.7803206 15.829325 11.7803206 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-9",
      "points": "12.6800882 15.6205125 12.6800882 0.0043875 0.813595588 0.0043875 0.813595588 15.6205125 12.6800882 15.6205125"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-11",
      "points": "13.7349882 0.1115 0.0210617647 0.1115 0.0210617647 15.8751125 13.7349882 15.8751125 13.7349882 0.1115"
    }
  }), _c('polygon', {
    attrs: {
      "id": "path-13",
      "points": "0.961254412 15.875 17.4086809 15.875 17.4086809 0.1115 0.961254412 0.1115"
    }
  })]), _c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-65.000000, -71.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1-Copy",
      "transform": "translate(65.000000, 71.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-3",
      "transform": "translate(18.117647, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-1",
      "d": "M7.38260147,15.875225 L8.29527794,15.875225 C11.9799544,15.6401 14.9082191,12.594725 14.9082191,8.87435 L14.9082191,0.1106 L10.8894985,0.1106 L10.8894985,8.87435 C10.8894985,10.5461 9.52048382,11.906225 7.83893971,11.906225 C6.15626324,11.906225 4.78724853,10.5461 4.78724853,8.87435 L4.78724853,0.1106 L0.768527941,0.1106 L0.768527941,8.87435 C0.768527941,12.594725 3.69679265,15.6401 7.38260147,15.875225",
      "mask": "url(#mask-2)"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-6",
      "transform": "translate(0.000000, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-4",
      "d": "M7.93881324,5.2173125 L9.40634265,8.9466875 C8.43365147,9.0164375 7.46775441,9.1581875 6.50978382,9.3449375 L7.93881324,5.2173125 Z M4.24960735,15.8755625 L4.95053382,13.8494375 C6.90044559,13.2183125 8.91829853,12.8943125 10.9542691,12.8785625 L12.1341809,15.8755625 L16.4484456,15.8755625 L10.2431515,0.1109375 L5.45669559,0.1109375 L-0.000113235294,15.8755625 L4.24960735,15.8755625 Z",
      "mask": "url(#mask-4)"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-9",
      "transform": "translate(89.455882, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-7",
      "d": "M4.57221471,4.107725 L7.89227353,4.107725 C8.89100882,4.107725 9.70517059,4.915475 9.70517059,5.907725 C9.70517059,6.899975 8.89100882,7.707725 7.89227353,7.707725 L4.57221471,7.707725 L4.57221471,4.107725 Z M4.57221471,15.74585 L4.57221471,11.70035 L7.76658235,11.70035 L9.80368529,15.875225 L14.2674206,15.875225 L11.5882735,10.382975 C12.8904794,9.31985 13.7227588,7.70885 13.7227588,5.907725 C13.7227588,2.71385 11.1070235,0.1151 7.89227353,0.1151 L4.57221471,0.1151 L4.57221471,0.1106 L0.554626471,0.1106 L0.554626471,15.74585 L4.57221471,15.74585 Z",
      "mask": "url(#mask-6)"
    }
  })]), _c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-10",
      "d": "M61.9710721,11.919725 C59.811675,11.919725 58.0531309,10.173725 58.0531309,8.027225 C58.0531309,5.88185 59.811675,4.134725 61.9710721,4.134725 C64.1304691,4.134725 65.8878809,5.88185 65.8878809,8.027225 C65.8878809,10.173725 64.1304691,11.919725 61.9710721,11.919725 M69.9066015,8.027225 C69.9066015,3.680225 66.3464838,0.143225 61.9710721,0.143225 C57.5956603,0.143225 54.0355426,3.680225 54.0355426,8.027225 C54.0355426,12.22235 57.3522044,15.65135 61.5147338,15.888725 L62.4274103,15.888725 C66.5899397,15.65135 69.9066015,12.22235 69.9066015,8.027225"
    }
  }), _c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-12",
      "d": "M86.6954324,12.578975 L83.4172706,10.26935 C82.6801088,11.303225 81.4843441,11.919725 80.2195059,11.919725 C78.0601088,11.919725 76.3026971,10.173725 76.3026971,8.027225 C76.3026971,5.88185 78.0601088,4.134725 80.2195059,4.134725 C81.4843441,4.134725 82.6801088,4.75235 83.4172706,5.7851 L86.6954324,3.477725 C85.2063882,1.389725 82.7854176,0.143225 80.2195059,0.143225 C75.8440941,0.143225 72.2839765,3.680225 72.2839765,8.027225 C72.2839765,12.22235 75.6006382,15.65135 79.7631676,15.888725 L80.5999765,15.888725 C83.0220794,15.771725 85.2799912,14.56235 86.6954324,12.578975"
    }
  }), _c('g', {
    attrs: {
      "id": "Group-16",
      "transform": "translate(125.691176, 0.013950)"
    }
  }, [_c('polygon', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-14",
      "mask": "url(#mask-8)",
      "points": "0.323173529 0.1109375 0.323173529 15.8294375 4.34076176 15.8294375 4.34076176 10.9131875 10.2233353 10.9131875 10.2233353 6.9216875 4.34076176 6.9216875 4.34076176 4.1204375 11.7803206 4.1204375 11.7803206 0.1109375"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-19",
      "transform": "translate(140.411765, 0.138950)"
    }
  }, [_c('polygon', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-17",
      "mask": "url(#mask-10)",
      "points": "0.813595588 3.9958875 4.73833088 3.9958875 4.73833088 15.6205125 8.75591912 15.6205125 8.75591912 3.9958875 12.6806544 3.9958875 12.6806544 0.0043875 0.813595588 0.0043875"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-22",
      "transform": "translate(37.367647, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-20",
      "d": "M4.03865,4.107725 L7.35984118,4.107725 C8.35857647,4.107725 9.17160588,4.915475 9.17160588,5.907725 C9.17160588,6.899975 8.35857647,7.707725 7.35984118,7.707725 L4.03865,7.707725 L4.03865,4.107725 Z M4.03865,15.74585 L4.03865,11.70035 L7.23301765,11.70035 L9.27012059,15.875225 L13.7349882,15.875225 L11.0558412,10.382975 C12.3580471,9.320975 13.1903265,7.70885 13.1903265,5.907725 C13.1903265,2.71385 10.5745912,0.1151 7.35984118,0.1151 L4.03865,0.1151 L4.03865,0.1106 L0.0210617647,0.1106 L0.0210617647,15.74585 L4.03865,15.74585 Z",
      "mask": "url(#mask-12)"
    }
  })]), _c('g', {
    attrs: {
      "id": "Group-25",
      "transform": "translate(105.308824, 0.013950)"
    }
  }, [_c('path', {
    staticClass: "letter",
    attrs: {
      "id": "Fill-23",
      "d": "M7.47115147,9.3449375 L8.90018088,5.2184375 L10.3677103,8.9466875 C9.39388676,9.0164375 8.42912206,9.1581875 7.47115147,9.3449375 L7.47115147,9.3449375 Z M6.41806324,0.1109375 L0.961254412,15.8755625 L5.210975,15.8755625 L5.91303382,13.8494375 C7.86068088,13.2183125 9.87966618,12.8943125 11.9145044,12.8785625 L13.0944162,15.8755625 L17.4086809,15.8755625 L11.2033868,0.1109375 L6.41806324,0.1109375 Z",
      "mask": "url(#mask-14)"
    }
  })])])])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dot-nav",
    class: {
      'is-inverted': _vm.inverted
    }
  }, [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    ref: "line",
    staticClass: "list-line"
  }), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      ref: "items",
      refInFor: true,
      staticClass: "list-item",
      class: {
        'is-active': index === _vm.current && !_vm.animating
      }
    }, [_c('span', {
      staticClass: "list-item__dot",
      class: {
        'has-label': item.label
      }
    }), _c('transition', {
      on: {
        "enter": _vm.labelEnter,
        "leave": _vm.labelLeave
      }
    }, [(item.label && index === _vm.current && !_vm.animating) ? _c('div', {
      staticClass: "list-item__label"
    }, [_c('span', [_vm._v(_vm._s(item.label))])]) : _vm._e()])], 1)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "menu-button",
    class: {
      'is-crossed': _vm.isPopupOpened
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('div', {
    ref: "line1",
    staticClass: "icon__line line-1"
  }), _c('div', {
    ref: "line2",
    staticClass: "icon__line line-2"
  })])])
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "slide intro intro-wrap"
  }, [_c('div', {
    ref: "media",
    staticClass: "intro-media"
  }, [(_vm.isMobile) ? _c('img', {
    staticClass: "intro-media__image",
    attrs: {
      "src": "/bundle/images/intro-slide-image.svg",
      "alt": "image"
    }
  }) : _c('div', {
    ref: "canvas",
    staticClass: "intro-media__canvas"
  })]), _c('article', {
    staticClass: "intro-content"
  }, [_c('h1', {
    staticClass: "intro-content__label",
    attrs: {
      "data-item": "data-item"
    }
  }, [_vm._v(_vm._s(_vm.label))]), _c('h2', {
    staticClass: "intro-content__heading",
    attrs: {
      "data-item": "data-item"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.head)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    ref: "bg",
    staticClass: "widget__background"
  }), _c('div', {
    staticClass: "widget__content"
  }, [_c('div', {
    staticClass: "widget__text"
  }, [(_vm.content.title) ? _c('div', {
    ref: "title",
    staticClass: "widget-title"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), (_vm.content.description) ? _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.content.description),
      expression: "content.description"
    }],
    ref: "content",
    staticClass: "widget-description markdown-container"
  }) : _vm._e()]), _c('div', {
    staticClass: "widget__slider slider"
  }, [_c('div', {
    staticClass: "slider-arrows-container"
  }, [_c('div', {
    ref: "arrows",
    staticClass: "slider-arrows"
  }, [_c('button', {
    staticClass: "slider-arrows__item slider-arrow",
    attrs: {
      "type": "button",
      "disabled": _vm.scroll <= _vm.offset
    },
    on: {
      "click": function($event) {
        _vm.changeSlide(-1)
      }
    }
  }, [_c('img', {
    staticClass: "slider-arrow__static",
    attrs: {
      "src": __webpack_require__(427)
    }
  }), _c('img', {
    staticClass: "slider-arrow__hover",
    attrs: {
      "src": __webpack_require__(133)
    }
  })]), _c('button', {
    staticClass: "slider-arrows__item slider-arrow",
    attrs: {
      "type": "button",
      "disabled": _vm.scroll >= _vm.maxScroll - _vm.offset
    },
    on: {
      "click": function($event) {
        _vm.changeSlide(1)
      }
    }
  }, [_c('img', {
    staticClass: "slider-arrow__static",
    attrs: {
      "src": __webpack_require__(426)
    }
  }), _c('img', {
    staticClass: "slider-arrow__hover",
    attrs: {
      "src": __webpack_require__(132)
    }
  })])])]), _c('div', {
    staticClass: "slider-container"
  }, [_c('div', {
    ref: "scrollable",
    staticClass: "slider-scrollable",
    on: {
      "scroll": _vm.getScroll
    }
  }, [_c('div', {
    ref: "track",
    staticClass: "slider-track"
  }, _vm._l((_vm.content.items.media), function(slide, index) {
    return _c('div', {
      key: index,
      ref: "slides",
      refInFor: true,
      staticClass: "slide"
    }, [_c('img', {
      ref: "img",
      refInFor: true,
      attrs: {
        "src": slide.url,
        "alt": "slider image"
      }
    })])
  }))])])])])])
},staticRenderFns: []}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "button-wrapper"
  }, [_c('div', {
    staticClass: "button-circle",
    class: [_vm.isLoading ? 'is-loading' : '']
  }, _vm._l(([, , , ]), function(dot) {
    return _c('div', {
      staticClass: "button-dot"
    })
  })), _c('div', {
    staticClass: "button-label"
  }, [_vm._v(_vm._s(_vm.isLoading ? _vm.$t('load') : _vm.$t('load-more')))])])])
},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup",
    class: {
      'is-opened': _vm.isPopupOpened
    }
  }, [_c('transition-wrapper', {
    on: {
      "transition-start": _vm.onAnimationStart,
      "transition-end": _vm.onAnimationEnd
    }
  }, [(_vm.isMenuOpened) ? _c('the-menu') : _vm._e()], 1), _c('transition-wrapper', {
    on: {
      "transition-start": _vm.onAnimationStart,
      "transition-end": _vm.onAnimationEnd
    }
  }, [(_vm.isFormOpened) ? _c('feedback-form') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "widget__content"
  }, [_c('div', {
    staticClass: "widget__row"
  }, [_c('div', {
    staticClass: "widget__column project-details"
  }, [(_vm.content.entityType) ? _c('div', {
    ref: "type",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-type')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.entityType))])]) : _vm._e(), (_vm.content.year) ? _c('div', {
    ref: "year",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-year')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.year))])]) : _vm._e(), (_vm.content.client) ? _c('div', {
    ref: "client",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-client')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.client))])]) : _vm._e()]), _c('div', {
    staticClass: "widget__column widget__column--btn"
  }, [(_vm.content.link && _vm.content.link.url) ? _c('base-button', {
    ref: "button",
    staticClass: "project-url",
    attrs: {
      "url": _vm.content.link.url,
      "label": _vm.$t('launch-website'),
      "target": "_blank"
    }
  }) : _vm._e()], 1)]), (_vm.content.goal) ? _c('div', {
    staticClass: "widget__row"
  }, [_c('div', {
    ref: "goal",
    staticClass: "widget-item"
  }, [_c('div', {
    staticClass: "widget-item__title"
  }, [_vm._v(_vm._s(_vm.$t('project-goals')) + ":")]), _c('div', {
    staticClass: "widget-item__content"
  }, [_vm._v(_vm._s(_vm.content.goal))])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    on: {
      "click": _vm.getSlideIndex
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "widget__content"
  }, [(_vm.content.title) ? _c('h2', {
    ref: "title",
    staticClass: "widget__title"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), (_vm.content.description) ? _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.content.description),
      expression: "content.description"
    }],
    ref: "content",
    staticClass: "widget__description markdown-container"
  }) : _vm._e(), _c('div', {
    staticClass: "widget__media",
    class: ['is-' + _vm.content.sizes]
  }, [_c('img', {
    ref: "media",
    attrs: {
      "src": _vm.content.media.url,
      "alt": "image"
    }
  })]), (_vm.content.note) ? _c('div', {
    ref: "note",
    staticClass: "widget__note"
  }, [_vm._v(_vm._s(_vm.content.note))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "partners__wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header__main hgroup"
  }, [_c('h2', {
    ref: "heading",
    staticClass: "hgroup__heading"
  }, [_vm._v(_vm._s(_vm.$content.title))]), _c('div', {
    ref: "subheading",
    staticClass: "hgroup__description"
  }, [_vm._v(_vm._s(_vm.$content.description))])]), _c('div', {
    ref: "aside",
    staticClass: "header__aside aside"
  }, [_c('base-button', {
    staticClass: "aside__button",
    attrs: {
      "label": _vm.$content.link.name,
      "url": _vm.$content.link.url,
      "target": "_blank"
    }
  })], 1)]), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "content__list list"
  }, _vm._l((_vm.$content.items), function(partner) {
    return _c('li', {
      ref: "items",
      refInFor: true,
      staticClass: "list__item",
      on: {
        "mouseenter": function($event) {
          _vm.hover = true
        },
        "mouseleave": function($event) {
          _vm.hover = false
        }
      }
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": partner.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "link__image"
    }, [_c('img', {
      attrs: {
        "src": partner.image.url
      }
    })]), _c('div', {
      staticClass: "link__label"
    }, [_vm._v(_vm._s(partner.title))])])])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-wrap"
  }, [_c('div', {
    ref: "track",
    staticClass: "slider__scrollable"
  }, [_c('div', {
    staticClass: "slider__track"
  }, _vm._l((_vm.slideList), function(slide, index) {
    return _c('slide', {
      directives: [{
        name: "touch",
        rawName: "v-touch:swipedown",
        value: (_vm.scrollUp),
        expression: "scrollUp",
        arg: "swipedown"
      }, {
        name: "touch",
        rawName: "v-touch:swipeleft",
        value: (_vm.nextSlide),
        expression: "nextSlide",
        arg: "swipeleft"
      }, {
        name: "touch",
        rawName: "v-touch:swiperight",
        value: (_vm.prevSlide),
        expression: "prevSlide",
        arg: "swiperight"
      }],
      key: index,
      ref: "slides",
      refInFor: true,
      class: {
        'is-active': _vm.currentSlide === index
      },
      attrs: {
        "indexSlide": index
      },
      on: {
        "slideClick": _vm.setSlide
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/' + _vm.lang + slide.url
      }
    }, [(slide.epigraph) ? _c('div', {
      staticClass: "slide__label"
    }, [_vm._v(_vm._s(slide.epigraph))]) : _vm._e(), _c('h2', {
      staticClass: "slide__title"
    }, [_vm._v(_vm._s(slide.name))]), _c('div', {
      staticClass: "slide__marker marker"
    }, [_c('div', {
      staticClass: "marker__bar"
    }), _c('div', {
      staticClass: "marker__dot"
    })])])], 1)
  }))]), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [_c('dots', {
    staticClass: "footer-slider__navigation",
    attrs: {
      "items": _vm.slideList,
      "current": _vm.currentSlide,
      "inverted": true
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [(!_vm.$store.getters.isLoading) ? _c('div', {
    staticClass: "homepage__content"
  }, [_vm._m(0), _c('div', {
    ref: "scroller",
    staticClass: "homepage__slider fullscreen-slider",
    class: {
      'is-intro': _vm.isIntro, 'is-last': _vm.isLast
    },
    attrs: {
      "block": _vm.isAnimating || _vm.$store.getters.isPopupOpened
    }
  }, [_c('transition-wrapper', {
    attrs: {
      "mode": "out-in",
      "appear": true
    },
    on: {
      "transition-start": function($event) {
        _vm.isAnimating = true
      },
      "transition-end": function($event) {
        _vm.isAnimating = false
      }
    }
  }, [(_vm.isIntro) ? _c('intro-slide', {
    staticClass: "fullscreen-slider__slide",
    attrs: {
      "label": _vm.pageContent.title,
      "head": _vm.pageContent.description
    }
  }) : (!_vm.isLast) ? _c('regular-slide', {
    key: _vm.currentSlide,
    staticClass: "fullscreen-slider__slide",
    attrs: {
      "slides": _vm.slides,
      "image": _vm.currentSlideData.media.url,
      "media": _vm.currentSlideData.media.json,
      "media-loop": _vm.currentSlideData.media.loop,
      "title": _vm.currentSlideData.title,
      "text": _vm.currentSlideData.description
    }
  }) : _c('empty-slide', {
    key: _vm.currentSlide,
    staticClass: "fullscreen-slide__slide"
  })], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.isIntro) ? _c('dots', {
    key: _vm.isIntro,
    staticClass: "fullscreen-slider__navigation is-intro",
    attrs: {
      "items": _vm.navigationItems,
      "current": _vm.currentSlide
    }
  }) : _c('dots', {
    key: _vm.isIntro,
    staticClass: "fullscreen-slider__navigation",
    attrs: {
      "items": _vm.navigationItems,
      "current": _vm.currentSlide
    }
  })], 1)], 1), _c('the-footer', {
    staticClass: "homepage__footer",
    attrs: {
      "block": !_vm.isLast
    },
    on: {
      "scroll-up": _vm.prevSlide
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "magicTriggerBox"
  }, [_c('div', {
    staticClass: "magicTrigger1"
  })])
}]}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "page"
  }, [_c('header', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro__content"
  }, [(_vm.type === 'story') ? _c('div', {
    staticClass: "intro__time",
    attrs: {
      "data-item": "data-item"
    }
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.$content.createdAt)))]) : _vm._e(), _c('div', {
    staticClass: "intro__title",
    attrs: {
      "data-item": "data-item"
    }
  }, [_vm._v(_vm._s(_vm.$content.title))]), (_vm.$content.description) ? _c('div', {
    staticClass: "intro__description",
    attrs: {
      "data-item": "data-item"
    }
  }, [_vm._v(_vm._s(_vm.$content.description))]) : _vm._e(), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.scrollVisible) ? _c('scroll-marker', {
    staticClass: "intro__scroll",
    attrs: {
      "dark-mode": true
    },
    on: {
      "click": _vm.scroll
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    ref: "image",
    staticClass: "intro__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.$content.pageMedia.image.url,
      "alt": "image"
    }
  })])]), _c('main', {
    staticClass: "main"
  }, [_vm._l((_vm.$content.widgets), function(widget) {
    return [(_vm.validateWidget(widget)) ? _c('appearance-wrapper', [_c(_vm.getWidgetType(widget.type), {
      key: widget.id,
      tag: "component",
      attrs: {
        "content": widget
      }
    })], 1) : _vm._e()]
  })], 2), _c('appearance-wrapper', [_c('the-footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader__background"
  }), _c('div', {
    staticClass: "loader__content"
  }, [_c('span', {
    staticClass: "spinner"
  }), _c('transition-wrapper', {
    attrs: {
      "name": "fade"
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(this.$t('load') !== 'load') ? _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('load')))]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroller-container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lang-switcher",
    class: [_vm.menuOpenMobile ? 'lang-switcher--open' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "lang-button lang-button--main",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.opened = !_vm.opened
      }
    }
  }, [_c('div', {
    staticClass: "lang-button__content"
  }, [_c('span', {
    staticClass: "lang-button__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.currentLang.label)))])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.opened || _vm.menuOpenMobile) ? _c('div', {
    staticClass: "langs"
  }, _vm._l((_vm.availableLangs), function(lang) {
    return _c('router-link', {
      key: lang.id,
      staticClass: "lang-button",
      attrs: {
        "to": _vm.getLangUrl(lang.id)
      },
      nativeOn: {
        "click": function($event) {
          _vm.onLangChange($event)
        }
      }
    }, [_c('div', {
      staticClass: "lang-button__content"
    }, [_c('span', {
      staticClass: "lang-button__label"
    }, [_vm._v(_vm._s(_vm.$t(lang.label)))])])])
  })) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "scroll-marker",
    class: {
      'is-standby': _vm.standby, 'is-dark': _vm.darkMode
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "scroll-marker__inner"
  }, [_c('div', {
    staticClass: "label"
  }, [_c('span', {
    ref: "label",
    staticClass: "label__content"
  }, [_vm._v(_vm._s(_vm.label))])]), _c('div', {
    staticClass: "graphic"
  }, [_c('div', {
    ref: "bar",
    staticClass: "graphic-bar"
  }, [_c('div', {
    ref: "barPoint",
    staticClass: "graphic-bar__point"
  })]), _c('div', {
    ref: "arrow",
    staticClass: "graphic-arrow"
  }, [_c('div', {
    ref: "arrowTip",
    staticClass: "graphic-arrow__tip"
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contacts-page"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "contacts-page__main"
  }, [_c('div', {
    staticClass: "contacts-page__container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isFormOpened) ? _c('ul', {
    staticClass: "contacts-list"
  }, _vm._l((_vm.contacts), function(contact) {
    return _c('li', {
      ref: "contacts",
      refInFor: true,
      staticClass: "contact"
    }, [_c('div', {
      staticClass: "contact__label"
    }, [_vm._v(_vm._s(contact.label))]), _c('div', {
      staticClass: "contact__value"
    }, [_vm._v(_vm._s(contact.content))]), (!_vm.isFormOpened && contact.url.length > 0 && contact.labelUrl.length > 0) ? _c('base-button', {
      ref: "mapButton",
      refInFor: true,
      staticClass: "map-link",
      attrs: {
        "url": contact.url,
        "label": contact.labelUrl
      }
    }) : _vm._e()], 1)
  })) : _vm._e()])], 1)]), (this.windowWidth > 1024) ? _c('div', {
    staticClass: "contacts-page__aside aside-container"
  }, [_c('div', {
    staticClass: "aside-inner"
  }, [_c('div', {
    ref: "background",
    staticClass: "aside-inner__background",
    class: {
      'is-wide': _vm.isFormOpened
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isFormOpened) ? _c('button', {
    ref: "button",
    staticClass: "trigger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openForm
    }
  }, [_c('div', {
    staticClass: "trigger__wrap"
  }, [_c('img', {
    staticClass: "trigger__icon",
    attrs: {
      "src": __webpack_require__(429),
      "alt": "form icon"
    }
  }), _c('span', {
    staticClass: "trigger__label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('write-to-us'))
    }
  })])]) : _vm._e()])], 1)]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm._url,
      "target": _vm.target
    },
    on: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "label",
    class: {
      'is-white': _vm.white
    }
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}

/***/ })
],[208]);


// WEBPACK FOOTER //
// bundle/js/app.js